export const DictionaryIllustrator_zh_CN = [
    {
        id: 18,
        label: '编辑 > 贴在前面',
        placement: 'MenuBar',
        name: '贴在前面',
    },
    {
        id: 19,
        label: '编辑 > 贴在后面',
        placement: 'MenuBar',
        name: '贴在后面',
    },
    {
        id: 20,
        label: '文件 > 从模板新建...',
        placement: 'MenuBar',
        name: '从模板新建...',
    },
    {
        id: 22,
        label: '对象 > 变换 > 再次变换',
        placement: 'MenuBar',
        name: '再次变换',
    },
    {
        id: 23,
        label: '对象 > 编组',
        placement: 'MenuBar',
        name: '编组',
    },
    {
        id: 24,
        label: '对象 > 取消编组',
        placement: 'MenuBar',
        name: '取消编组',
    },
    {
        id: 25,
        label: '对象 > 路径 > 连接',
        placement: 'MenuBar',
        name: '连接',
    },
    {
        id: 26,
        label: '对象 > 路径 > 平均...',
        placement: 'MenuBar',
        name: '平均...',
    },
    {
        id: 28,
        label: '对象 > 锁定 > 所选对象',
        placement: 'MenuBar',
        name: '所选对象',
    },
    {
        id: 29,
        label: '对象 > 全部解锁',
        placement: 'MenuBar',
        name: '全部解锁',
    },
    {
        id: 30,
        label: '视图 > 预览',
        placement: 'MenuBar',
        name: '预览',
    },
    {
        id: 33,
        label: '视图 > 像素预览',
        placement: 'MenuBar',
        name: '像素预览',
    },
    {
        id: 34,
        label: '文字 > 区域文字选项...',
        placement: 'MenuBar',
        name: '区域文字选项...',
    },
    {
        id: 35,
        label: '视图 > 画板适合窗口大小',
        placement: 'MenuBar',
        name: '画板适合窗口大小',
    },
    {
        id: 36,
        label: '窗口 > 新建窗口',
        placement: 'MenuBar',
        name: '新建窗口',
    },
    {
        id: 37,
        label: '视图 > 标尺 > 显示标尺',
        placement: 'MenuBar',
        name: '显示标尺',
    },
    {
        id: 38,
        label: '文字 > 路径文字 > 3D 带状效果',
        placement: 'MenuBar',
        name: '3D 带状效果',
    },
    {
        id: 40,
        label: '文字 > 路径文字 > 阶梯效果',
        placement: 'MenuBar',
        name: '阶梯效果',
    },
    {
        id: 42,
        label: '对象 > 排列 > 置于顶层',
        placement: 'MenuBar',
        name: '置于顶层',
    },
    {
        id: 43,
        label: '对象 > 排列 > 置于底层',
        placement: 'MenuBar',
        name: '置于底层',
    },
    {
        id: 48,
        label: '文件 > 存储为模板...',
        placement: 'MenuBar',
        name: '存储为模板...',
    },
    {
        id: 50,
        label: '对象 > 隐藏 > 所选对象',
        placement: 'MenuBar',
        name: '所选对象',
    },
    {
        id: 51,
        label: '对象 > 显示全部',
        placement: 'MenuBar',
        name: '显示全部',
    },
    {
        id: 52,
        label: '视图 > 参考线 > 建立参考线',
        placement: 'MenuBar',
        name: '建立参考线',
    },
    {
        id: 53,
        label: '视图 > 参考线 > 释放参考线',
        placement: 'MenuBar',
        name: '释放参考线',
    },
    {
        id: 54,
        label: '对象 > 变换 > 移动...',
        placement: 'MenuBar',
        name: '移动...',
    },
    {
        id: 55,
        label: 'Illustrator > 首选项 > 智能参考线...',
        placement: 'MenuBar',
        name: '智能参考线...',
    },
    {
        id: 56,
        label: '对象 > 复合路径 > 建立',
        placement: 'MenuBar',
        name: '建立',
    },
    {
        id: 57,
        label: '对象 > 复合路径 > 释放',
        placement: 'MenuBar',
        name: '释放',
    },
    {
        id: 62,
        label: '文字 > 创建轮廓',
        placement: 'MenuBar',
        name: '创建轮廓',
    },
    {
        id: 63,
        label: '视图 > 实际大小',
        placement: 'MenuBar',
        name: '实际大小',
    },
    {
        id: 74,
        label: '对象 > 图表 > 类型...',
        placement: 'MenuBar',
        name: '类型...',
    },
    {
        id: 75,
        label: '对象 > 图表 > 数据...',
        placement: 'MenuBar',
        name: '数据...',
    },
    {
        id: 76,
        label: '对象 > 图表 > 柱形图...',
        placement: 'MenuBar',
        name: '柱形图...',
    },
    {
        id: 77,
        label: '对象 > 图表 > 设计...',
        placement: 'MenuBar',
        name: '设计...',
    },
    {
        id: 78,
        label: '对象 > 图表 > 标记...',
        placement: 'MenuBar',
        name: '标记...',
    },
    {
        id: 83,
        label: '文字 > 路径文字 > 彩虹效果',
        placement: 'MenuBar',
        name: '彩虹效果',
    },
    {
        id: 84,
        label: '文件 > 文档设置...',
        placement: 'MenuBar',
        name: '文档设置...',
    },
    {
        id: 85,
        label: '视图 > 隐藏打印拼贴',
        placement: 'MenuBar',
        name: '隐藏打印拼贴',
    },
    {
        id: 86,
        label: '视图 > 隐藏画板',
        placement: 'MenuBar',
        name: '隐藏画板',
    },
    {
        id: 87,
        label: '文字 > 适合标题',
        placement: 'MenuBar',
        name: '适合标题',
    },
    {
        id: 95,
        label: '文件 > 存储副本...',
        placement: 'MenuBar',
        name: '存储副本...',
    },
    {
        id: 98,
        label: 'Illustrator > 首选项 > 文字...',
        placement: 'MenuBar',
        name: '文字...',
    },
    {
        id: 99,
        label: 'Illustrator > 首选项 > 单位...',
        placement: 'MenuBar',
        name: '单位...',
    },
    {
        id: 100,
        label: '对象 > 排列 > 前移一层',
        placement: 'MenuBar',
        name: '前移一层',
    },
    {
        id: 101,
        label: '对象 > 排列 > 后移一层',
        placement: 'MenuBar',
        name: '后移一层',
    },
    {
        id: 109,
        label: '窗口 > 排列 > 最小化窗口',
        placement: 'MenuBar',
        name: '最小化窗口',
    },
    {
        id: 110,
        label: '窗口 > 排列 > 全部置于顶层',
        placement: 'MenuBar',
        name: '全部置于顶层',
    },
    {
        id: 113,
        label: '视图 > 参考线 > 清除参考线',
        placement: 'MenuBar',
        name: '清除参考线',
    },
    {
        id: 114,
        label: '视图 > 显示模板',
        placement: 'MenuBar',
        name: '显示模板',
    },
    {
        id: 115,
        label: '文字 > 显示隐藏字符',
        placement: 'MenuBar',
        name: '显示隐藏字符',
    },
    {
        id: 116,
        label: '文字 > 路径文字 > 倾斜效果',
        placement: 'MenuBar',
        name: '倾斜效果',
    },
    {
        id: 117,
        label: '文件 > 关闭全部',
        placement: 'MenuBar',
        name: '关闭全部',
    },
    {
        id: 119,
        label: '文字 > 路径文字 > 重力效果',
        placement: 'MenuBar',
        name: '重力效果',
    },
    {
        id: 120,
        label: '对象 > 剪切蒙版 > 建立',
        placement: 'MenuBar',
        name: '建立',
    },
    {
        id: 121,
        label: '对象 > 剪切蒙版 > 释放',
        placement: 'MenuBar',
        name: '释放',
    },
    {
        id: 123,
        label: '文字 > 路径文字 > 路径文字选项...',
        placement: 'MenuBar',
        name: '路径文字选项...',
    },
    {
        id: 127,
        label: '对象 > 画板 > 转换为画板',
        placement: 'MenuBar',
        name: '转换为画板',
    },
    {
        id: 133,
        label: '文字 > 串接文本 > 创建',
        placement: 'MenuBar',
        name: '创建',
    },
    {
        id: 135,
        label: '视图 > 放大',
        placement: 'MenuBar',
        name: '放大',
    },
    {
        id: 136,
        label: '视图 > 缩小',
        placement: 'MenuBar',
        name: '缩小',
    },
    {
        id: 139,
        label: '编辑 > 颜色设置...',
        placement: 'MenuBar',
        name: '颜色设置...',
    },
    {
        id: 140,
        label: 'Illustrator > 首选项 > 连字...',
        placement: 'MenuBar',
        name: '连字...',
    },
    {
        id: 141,
        label: 'Illustrator > 首选项 > 增效工具和暂存盘...',
        placement: 'MenuBar',
        name: '增效工具和暂存盘...',
    },
    {
        id: 142,
        label: '选择 > 取消选择',
        placement: 'MenuBar',
        name: '取消选择',
    },
    {
        id: 143,
        label: '视图 > 叠印预览',
        placement: 'MenuBar',
        name: '叠印预览',
    },
    {
        id: 144,
        label: '视图 > 新建视图...',
        placement: 'MenuBar',
        name: '新建视图...',
    },
    {
        id: 145,
        label: '视图 > 编辑视图...',
        placement: 'MenuBar',
        name: '编辑视图...',
    },
    {
        id: 146,
        label: '视图 > 对齐点',
        placement: 'MenuBar',
        name: '对齐点',
    },
    {
        id: 147,
        label: '视图 > 隐藏边缘',
        placement: 'MenuBar',
        name: '隐藏边缘',
    },
    {
        id: 148,
        label: '对象 > 扩展外观',
        placement: 'MenuBar',
        name: '扩展外观',
    },
    {
        id: 150,
        label: '视图 > 显示文本串接',
        placement: 'MenuBar',
        name: '显示文本串接',
    },
    {
        id: 154,
        label: '视图 > 参考线 > 隐藏参考线',
        placement: 'MenuBar',
        name: '隐藏参考线',
    },
    {
        id: 155,
        label: '视图 > 参考线 > 锁定参考线',
        placement: 'MenuBar',
        name: '锁定参考线',
    },
    {
        id: 157,
        label: '文字 > 串接文本 > 释放所选文字',
        placement: 'MenuBar',
        name: '释放所选文字',
    },
    {
        id: 158,
        label: '文字 > 串接文本 > 移去串接文字',
        placement: 'MenuBar',
        name: '移去串接文字',
    },
    {
        id: 159,
        label: '视图 > 显示网格',
        placement: 'MenuBar',
        name: '显示网格',
    },
    {
        id: 160,
        label: '视图 > 对齐网格',
        placement: 'MenuBar',
        name: '对齐网格',
    },
    {
        id: 161,
        label: 'Illustrator > 首选项 > 参考线和网格...',
        placement: 'MenuBar',
        name: '参考线和网格...',
    },
    {
        id: 162,
        label: '对象 > 变换 > 旋转...',
        placement: 'MenuBar',
        name: '旋转...',
    },
    {
        id: 163,
        label: '对象 > 变换 > 缩放...',
        placement: 'MenuBar',
        name: '缩放...',
    },
    {
        id: 164,
        label: '对象 > 变换 > 镜像...',
        placement: 'MenuBar',
        name: '镜像...',
    },
    {
        id: 165,
        label: '对象 > 变换 > 倾斜...',
        placement: 'MenuBar',
        name: '倾斜...',
    },
    {
        id: 166,
        label: '窗口 > 排列 > 层叠',
        placement: 'MenuBar',
        name: '层叠',
    },
    {
        id: 168,
        label: '窗口 > 排列 > 平铺',
        placement: 'MenuBar',
        name: '平铺',
    },
    {
        id: 202,
        label: '视图 > 校样颜色',
        placement: 'MenuBar',
        name: '校样颜色',
    },
    {
        id: 203,
        label: '编辑 > 指定配置文件...',
        placement: 'MenuBar',
        name: '指定配置文件...',
    },
    {
        id: 204,
        label: '帮助 > 教程...',
        placement: 'MenuBar',
        name: '教程...',
    },
    {
        id: 223,
        label: '文件 > 文档颜色模式 > CMYK 颜色',
        placement: 'MenuBar',
        name: 'CMYK 颜色',
    },
    {
        id: 224,
        label: '文件 > 文档颜色模式 > RGB 颜色',
        placement: 'MenuBar',
        name: 'RGB 颜色',
    },
    {
        id: 225,
        label: '视图 > 校样设置 > 文档 CMYK:',
        placement: 'MenuBar',
        name: '文档 CMYK:',
    },
    {
        id: 226,
        label: '视图 > 校样设置 > 旧版 Macintosh RGB（灰度系数 1.8）',
        placement: 'MenuBar',
        name: '旧版 Macintosh RGB（灰度系数 1.8）',
    },
    {
        id: 227,
        label: '视图 > 校样设置 > Internet 标准 RGB (sRGB)',
        placement: 'MenuBar',
        name: 'Internet 标准 RGB (sRGB)',
    },
    {
        id: 228,
        label: '视图 > 校样设置 > 显示器 RGB',
        placement: 'MenuBar',
        name: '显示器 RGB',
    },
    {
        id: 229,
        label: '文字 > 文字方向 > 水平',
        placement: 'MenuBar',
        name: '水平',
    },
    {
        id: 230,
        label: '文字 > 文字方向 > 垂直',
        placement: 'MenuBar',
        name: '垂直',
    },
    {
        id: 232,
        label: '帮助 > 系统信息...',
        placement: 'MenuBar',
        name: '系统信息...',
    },
    {
        id: 278,
        label: '文字 > 旧版文本 > 更新所有旧版文本',
        placement: 'MenuBar',
        name: '更新所有旧版文本',
    },
    {
        id: 279,
        label: '文字 > 旧版文本 > 更新所选的旧版文本',
        placement: 'MenuBar',
        name: '更新所选的旧版文本',
    },
    {
        id: 280,
        label: '文字 > 旧版文本 > 隐藏副本',
        placement: 'MenuBar',
        name: '隐藏副本',
    },
    {
        id: 281,
        label: '文字 > 旧版文本 > 删除副本',
        placement: 'MenuBar',
        name: '删除副本',
    },
    {
        id: 282,
        label: '文字 > 旧版文本 > 选择副本',
        placement: 'MenuBar',
        name: '选择副本',
    },
    {
        id: 284,
        label: '视图 > 校样设置 > 自定...',
        placement: 'MenuBar',
        name: '自定...',
    },
    {
        id: 289,
        label: 'Illustrator > 首选项 > 选择和锚点显示...',
        placement: 'MenuBar',
        name: '选择和锚点显示...',
    },
    {
        id: 292,
        label: '对象 > 剪切蒙版 > 编辑内容',
        placement: 'MenuBar',
        name: '编辑内容',
    },
    {
        id: 293,
        label: 'Illustrator > 首选项 > 用户界面...',
        placement: 'MenuBar',
        name: '用户界面...',
    },
    {
        id: 294,
        label: 'Illustrator > 首选项 > 切片...',
        placement: 'MenuBar',
        name: '切片...',
    },
    {
        id: 295,
        label: '窗口 > 应用程序框架',
        placement: 'MenuBar',
        name: '应用程序框架',
    },
    {
        id: 296,
        label: '视图 > 校样设置 > 色盲 - 红色色盲类型',
        placement: 'MenuBar',
        name: '色盲 - 红色色盲类型',
    },
    {
        id: 297,
        label: '视图 > 校样设置 > 色盲 - 绿色色盲类型',
        placement: 'MenuBar',
        name: '色盲 - 绿色色盲类型',
    },
    {
        id: 299,
        label: '视图 > 标尺 > 显示视频标尺',
        placement: 'MenuBar',
        name: '显示视频标尺',
    },
    {
        id: 301,
        label: '窗口 > 排列 > 在窗口中浮动',
        placement: 'MenuBar',
        name: '在窗口中浮动',
    },
    {
        id: 302,
        label: '窗口 > 排列 > 全部在窗口中浮动',
        placement: 'MenuBar',
        name: '全部在窗口中浮动',
    },
    {
        id: 303,
        label: '窗口 > 排列 > 合并所有窗口',
        placement: 'MenuBar',
        name: '合并所有窗口',
    },
    {
        id: 304,
        label: '窗口 > 应用程序栏',
        placement: 'MenuBar',
        name: '应用程序栏',
    },
    {
        id: 310,
        label: '文字 > 路径文字 > 更新旧版路径文字',
        placement: 'MenuBar',
        name: '更新旧版路径文字',
    },
    {
        id: 311,
        label: '视图 > 全部适合窗口大小',
        placement: 'MenuBar',
        name: '全部适合窗口大小',
    },
    {
        id: 315,
        label: '编辑 > 就地粘贴',
        placement: 'MenuBar',
        name: '就地粘贴',
    },
    {
        id: 316,
        label: '编辑 > 在所有画板上粘贴',
        placement: 'MenuBar',
        name: '在所有画板上粘贴',
    },
    {
        id: 331,
        label: '文字 > 文本类型转换',
        placement: 'MenuBar',
        name: '文本类型转换',
    },
    {
        id: 339,
        label: '编辑 > 我的设置 > 导出设置...',
        placement: 'MenuBar',
        name: '导出设置...',
    },
    {
        id: 340,
        label: '编辑 > 我的设置 > 导入设置...',
        placement: 'MenuBar',
        name: '导入设置...',
    },
    {
        id: 347,
        label: '视图 > 使用 GPU 查看',
        placement: 'MenuBar',
        name: '使用 GPU 查看',
    },
    {
        id: 351,
        label: '文件 > 导出所选项目...',
        placement: 'MenuBar',
        name: '导出所选项目...',
    },
    {
        id: 353,
        label: '视图 > 对齐像素',
        placement: 'MenuBar',
        name: '对齐像素',
    },
    {
        id: 354,
        label: '文件 > 导出 > 导出为多种屏幕所用格式...',
        placement: 'MenuBar',
        name: '导出为多种屏幕所用格式...',
    },
    {
        id: 355,
        label: '文件 > 导出 > 导出为...',
        placement: 'MenuBar',
        name: '导出为...',
    },
    {
        id: 356,
        label: '文件 > 导出 > 存储为 Web 所用格式（旧版）...',
        placement: 'MenuBar',
        name: '存储为 Web 所用格式（旧版）...',
    },
    {
        id: 368,
        label: '文字 > 插入特殊字符 > 符号 > 项目符号',
        placement: 'MenuBar',
        name: '项目符号',
    },
    {
        id: 369,
        label: '文字 > 插入特殊字符 > 符号 > 版权符号',
        placement: 'MenuBar',
        name: '版权符号',
    },
    {
        id: 370,
        label: '文字 > 插入特殊字符 > 符号 > 省略号',
        placement: 'MenuBar',
        name: '省略号',
    },
    {
        id: 371,
        label: '文字 > 插入特殊字符 > 符号 > 段落符号',
        placement: 'MenuBar',
        name: '段落符号',
    },
    {
        id: 372,
        label: '文字 > 插入特殊字符 > 符号 > 注册商标符号',
        placement: 'MenuBar',
        name: '注册商标符号',
    },
    {
        id: 373,
        label: '文字 > 插入特殊字符 > 符号 > 分节符',
        placement: 'MenuBar',
        name: '分节符',
    },
    {
        id: 374,
        label: '文字 > 插入特殊字符 > 符号 > 商标符号',
        placement: 'MenuBar',
        name: '商标符号',
    },
    {
        id: 375,
        label: '文字 > 插入特殊字符 > 引号 > 左双引号',
        placement: 'MenuBar',
        name: '左双引号',
    },
    {
        id: 376,
        label: '文字 > 插入特殊字符 > 引号 > 右双引号',
        placement: 'MenuBar',
        name: '右双引号',
    },
    {
        id: 377,
        label: '文字 > 插入特殊字符 > 引号 > 左单引号',
        placement: 'MenuBar',
        name: '左单引号',
    },
    {
        id: 378,
        label: '文字 > 插入特殊字符 > 引号 > 右单引号',
        placement: 'MenuBar',
        name: '右单引号',
    },
    {
        id: 379,
        label: '文字 > 插入特殊字符 > 连字符和破折号 > 全角破折号',
        placement: 'MenuBar',
        name: '全角破折号',
    },
    {
        id: 380,
        label: '文字 > 插入特殊字符 > 连字符和破折号 > 半角破折号',
        placement: 'MenuBar',
        name: '半角破折号',
    },
    {
        id: 381,
        label: '文字 > 插入特殊字符 > 连字符和破折号 > 自由连字符',
        placement: 'MenuBar',
        name: '自由连字符',
    },
    {
        id: 382,
        label: '文字 > 插入空白字符 > 全角空格',
        placement: 'MenuBar',
        name: '全角空格',
    },
    {
        id: 383,
        label: '文字 > 插入空白字符 > 半角空格',
        placement: 'MenuBar',
        name: '半角空格',
    },
    {
        id: 384,
        label: '文字 > 插入空白字符 > 微间隔',
        placement: 'MenuBar',
        name: '微间隔',
    },
    {
        id: 385,
        label: '文字 > 插入空白字符 > 窄间隔',
        placement: 'MenuBar',
        name: '窄间隔',
    },
    {
        id: 386,
        label: '文字 > 插入分隔符 > 强制换行符',
        placement: 'MenuBar',
        name: '强制换行符',
    },
    {
        id: 391,
        label: '文字 > 用占位符文本填充',
        placement: 'MenuBar',
        name: '用占位符文本填充',
    },
    {
        id: 393,
        label: '对象 > 收集以导出 > 作为单个资源',
        placement: 'MenuBar',
        name: '作为单个资源',
    },
    {
        id: 394,
        label: '对象 > 收集以导出 > 作为多个资源',
        placement: 'MenuBar',
        name: '作为多个资源',
    },
    {
        id: 396,
        label: '视图 > 裁切视图',
        placement: 'MenuBar',
        name: '裁切视图',
    },
    {
        id: 397,
        label: '视图 > 显示文稿模式',
        placement: 'MenuBar',
        name: '显示文稿模式',
    },
    {
        id: 404,
        label: '视图 > 屏幕模式 > 正常屏幕模式',
        placement: 'MenuBar',
        name: '正常屏幕模式',
    },
    {
        id: 405,
        label: '视图 > 屏幕模式 > 带有菜单栏的全屏模式',
        placement: 'MenuBar',
        name: '带有菜单栏的全屏模式',
    },
    {
        id: 406,
        label: '视图 > 屏幕模式 > 全屏模式',
        placement: 'MenuBar',
        name: '全屏模式',
    },
    {
        id: 411,
        label: '视图 > 对齐字形',
        placement: 'MenuBar',
        name: '对齐字形',
    },
    {
        id: 415,
        label: '视图 > 针对所选对象旋转视图',
        placement: 'MenuBar',
        name: '针对所选对象旋转视图',
    },
    {
        id: 417,
        label: '视图 > 旋转视图 > 180',
        placement: 'MenuBar',
        name: '180',
    },
    {
        id: 418,
        label: '视图 > 旋转视图 > 150',
        placement: 'MenuBar',
        name: '150',
    },
    {
        id: 419,
        label: '视图 > 旋转视图 > 135',
        placement: 'MenuBar',
        name: '135',
    },
    {
        id: 420,
        label: '视图 > 旋转视图 > 120',
        placement: 'MenuBar',
        name: '120',
    },
    {
        id: 421,
        label: '视图 > 旋转视图 > 90',
        placement: 'MenuBar',
        name: '90',
    },
    {
        id: 422,
        label: '视图 > 旋转视图 > 60',
        placement: 'MenuBar',
        name: '60',
    },
    {
        id: 423,
        label: '视图 > 旋转视图 > 45',
        placement: 'MenuBar',
        name: '45',
    },
    {
        id: 424,
        label: '视图 > 旋转视图 > 30',
        placement: 'MenuBar',
        name: '30',
    },
    {
        id: 425,
        label: '视图 > 旋转视图 > 15',
        placement: 'MenuBar',
        name: '15',
    },
    {
        id: 426,
        label: '视图 > 旋转视图 > 0',
        placement: 'MenuBar',
        name: '0',
    },
    {
        id: 427,
        label: '视图 > 旋转视图 > -15',
        placement: 'MenuBar',
        name: '-15',
    },
    {
        id: 428,
        label: '视图 > 旋转视图 > -30',
        placement: 'MenuBar',
        name: '-30',
    },
    {
        id: 429,
        label: '视图 > 旋转视图 > -45',
        placement: 'MenuBar',
        name: '-45',
    },
    {
        id: 430,
        label: '视图 > 旋转视图 > -60',
        placement: 'MenuBar',
        name: '-60',
    },
    {
        id: 431,
        label: '视图 > 旋转视图 > -90',
        placement: 'MenuBar',
        name: '-90',
    },
    {
        id: 432,
        label: '视图 > 旋转视图 > -120',
        placement: 'MenuBar',
        name: '-120',
    },
    {
        id: 433,
        label: '视图 > 旋转视图 > -135',
        placement: 'MenuBar',
        name: '-135',
    },
    {
        id: 434,
        label: '视图 > 旋转视图 > -150',
        placement: 'MenuBar',
        name: '-150',
    },
    {
        id: 435,
        label: '视图 > 旋转视图 > -180',
        placement: 'MenuBar',
        name: '-180',
    },
    {
        id: 436,
        label: '视图 > 重置旋转视图',
        placement: 'MenuBar',
        name: '重置旋转视图',
    },
    {
        id: 437,
        label: '编辑 > 粘贴时不包含格式',
        placement: 'MenuBar',
        name: '粘贴时不包含格式',
    },
    {
        id: 438,
        label: '帮助 > 新增功能...',
        placement: 'MenuBar',
        name: '新增功能...',
    },
    {
        id: 440,
        label: '文字 > 项目符号和编号 > 应用项目符号',
        placement: 'MenuBar',
        name: '应用项目符号',
    },
    {
        id: 441,
        label: '文字 > 项目符号和编号 > 应用编号',
        placement: 'MenuBar',
        name: '应用编号',
    },
    {
        id: 448,
        label: '文字 > 项目符号和编号 > 转换为文本',
        placement: 'MenuBar',
        name: '转换为文本',
    },
    {
        id: 456,
        label: '文字 > Retype',
        placement: 'MenuBar',
        name: 'Retype',
    },
    {
        id: 471,
        label: '对象 > 取消全部编组',
        placement: 'MenuBar',
        name: '取消全部编组',
    },
    {
        id: 472,
        label: '文字 > 插入空白字符 > 不间断空格',
        placement: 'MenuBar',
        name: '不间断空格',
    },
    {
        id: 1383427079,
        label: '视图 > 标尺 > 更改为画板标尺',
        placement: 'MenuBar',
        name: '更改为画板标尺',
    },
    {
        id: 1633841013,
        label: 'Illustrator > 关于 Illustrator...',
        placement: 'MenuBar',
        name: '关于 Illustrator...',
    },
    {
        id: 1634233456,
        label: '帮助 > Illustrator 帮助...',
        placement: 'MenuBar',
        name: 'Illustrator 帮助...',
    },
    {
        id: 1634296684,
        label: '文件 > 关闭',
        placement: 'MenuBar',
        name: '关闭',
    },
    {
        id: 1668048225,
        label: '编辑 > 清除',
        placement: 'MenuBar',
        name: '清除',
    },
    {
        id: 1668247673,
        label: '编辑 > 复制',
        placement: 'MenuBar',
        name: '复制',
    },
    {
        id: 1668641824,
        label: '编辑 > 剪切',
        placement: 'MenuBar',
        name: '剪切',
    },
    {
        id: 1751737445,
        label: 'Illustrator > 隐藏 Illustrator',
        placement: 'MenuBar',
        name: '隐藏 Illustrator',
    },
    {
        id: 1751737455,
        label: 'Illustrator > 隐藏其他',
        placement: 'MenuBar',
        name: '隐藏其他',
    },
    {
        id: 1852143392,
        label: '文件 > 新建...',
        placement: 'MenuBar',
        name: '新建...',
    },
    {
        id: 1869636974,
        label: '文件 > 打开...',
        placement: 'MenuBar',
        name: '打开...',
    },
    {
        id: 1885434740,
        label: '编辑 > 粘贴',
        placement: 'MenuBar',
        name: '粘贴',
    },
    {
        id: 1886545254,
        label: 'Illustrator > 首选项 > 常规...',
        placement: 'MenuBar',
        name: '常规...',
    },
    {
        id: 1903520116,
        label: 'Illustrator > 退出 Illustrator',
        placement: 'MenuBar',
        name: '退出 Illustrator',
    },
    {
        id: 1919247471,
        label: '编辑 > 重做',
        placement: 'MenuBar',
        name: '重做',
    },
    {
        id: 1920365172,
        label: '文件 > 恢复',
        placement: 'MenuBar',
        name: '恢复',
    },
    {
        id: 1934727834,
        label: '选择 > 现用画板上的全部对象',
        placement: 'MenuBar',
        name: '现用画板上的全部对象',
    },
    {
        id: 1935764588,
        label: '选择 > 全部',
        placement: 'MenuBar',
        name: '全部',
    },
    {
        id: 1935767141,
        label: '文件 > 存储',
        placement: 'MenuBar',
        name: '存储',
    },
    {
        id: 1936220524,
        label: 'Illustrator > 显示全部对象',
        placement: 'MenuBar',
        name: '显示全部对象',
    },
    {
        id: 1936292352,
        label: '文字 > 大小 > 6 pt',
        placement: 'MenuBar',
        name: '6 pt',
    },
    {
        id: 1936292353,
        label: '文字 > 大小 > 7 pt',
        placement: 'MenuBar',
        name: '7 pt',
    },
    {
        id: 1936292354,
        label: '文字 > 大小 > 8 pt',
        placement: 'MenuBar',
        name: '8 pt',
    },
    {
        id: 1936292355,
        label: '文字 > 大小 > 9 pt',
        placement: 'MenuBar',
        name: '9 pt',
    },
    {
        id: 1936292356,
        label: '文字 > 大小 > 10 pt',
        placement: 'MenuBar',
        name: '10 pt',
    },
    {
        id: 1936292357,
        label: '文字 > 大小 > 11 pt',
        placement: 'MenuBar',
        name: '11 pt',
    },
    {
        id: 1936292358,
        label: '文字 > 大小 > 12 pt',
        placement: 'MenuBar',
        name: '12 pt',
    },
    {
        id: 1936292359,
        label: '文字 > 大小 > 14 pt',
        placement: 'MenuBar',
        name: '14 pt',
    },
    {
        id: 1936292360,
        label: '文字 > 大小 > 18 pt',
        placement: 'MenuBar',
        name: '18 pt',
    },
    {
        id: 1936292361,
        label: '文字 > 大小 > 21 pt',
        placement: 'MenuBar',
        name: '21 pt',
    },
    {
        id: 1936292362,
        label: '文字 > 大小 > 24 pt',
        placement: 'MenuBar',
        name: '24 pt',
    },
    {
        id: 1936292363,
        label: '文字 > 大小 > 36 pt',
        placement: 'MenuBar',
        name: '36 pt',
    },
    {
        id: 1936292364,
        label: '文字 > 大小 > 48 pt',
        placement: 'MenuBar',
        name: '48 pt',
    },
    {
        id: 1936292365,
        label: '文字 > 大小 > 60 pt',
        placement: 'MenuBar',
        name: '60 pt',
    },
    {
        id: 1936292366,
        label: '文字 > 大小 > 72 pt',
        placement: 'MenuBar',
        name: '72 pt',
    },
    {
        id: 1936292367,
        label: '文字 > 大小 > 其它...',
        placement: 'MenuBar',
        name: '其它...',
    },
    {
        id: 1937138035,
        label: '文件 > 存储为...',
        placement: 'MenuBar',
        name: '存储为...',
    },
    {
        id: 1970168943,
        label: '编辑 > 还原',
        placement: 'MenuBar',
        name: '还原',
    },
    {
        id: 2164260867,
        label: '帮助 > 管理我的帐户...',
        placement: 'MenuBar',
        name: '管理我的帐户...',
    },
    {
        id: 2164260869,
        label: '帮助 > 更新...',
        placement: 'MenuBar',
        name: '更新...',
    },
    {
        id: 2164260870,
        label: '效果 > 应用上一个效果',
        placement: 'MenuBar',
        name: '应用上一个效果',
    },
    {
        id: 2164260871,
        label: '效果 > 上一个效果',
        placement: 'MenuBar',
        name: '上一个效果',
    },
    {
        id: 2164260872,
        label: '文件 > 搜索 Adobe Stock...',
        placement: 'MenuBar',
        name: '搜索 Adobe Stock...',
    },
    {
        id: 2164260873,
        label: '文件 > 置入...',
        placement: 'MenuBar',
        name: '置入...',
    },
    {
        id: 2164260874,
        label: '对象 > 路径 > 移去锚点',
        placement: 'MenuBar',
        name: '移去锚点',
    },
    {
        id: 2164260877,
        label: '文字 > 复合字体...',
        placement: 'MenuBar',
        name: '复合字体...',
    },
    {
        id: 2164260879,
        label: '帮助 > Debug > Memory Use Checkpoint',
        placement: 'MenuBar',
        name: 'Memory Use Checkpoint',
    },
    {
        id: 2164260880,
        label: '帮助 > Debug > Save Memory Use',
        placement: 'MenuBar',
        name: 'Save Memory Use',
    },
    {
        id: 2164260882,
        label: '帮助 > Debug > Progress: Bar Shown',
        placement: 'MenuBar',
        name: 'Progress: Bar Shown',
    },
    {
        id: 2164260883,
        label: '帮助 > Debug > Progress: Tight loop for 120 Seconds',
        placement: 'MenuBar',
        name: 'Progress: Tight loop for 120 Seconds',
    },
    {
        id: 2164260884,
        label: '帮助 > Debug > Responsive Rate Test',
        placement: 'MenuBar',
        name: 'Responsive Rate Test',
    },
    {
        id: 2164260885,
        label: '帮助 > Debug > Test Notification 1',
        placement: 'MenuBar',
        name: 'Test Notification 1',
    },
    {
        id: 2164260886,
        label: '帮助 > Debug > Test Notification 2',
        placement: 'MenuBar',
        name: 'Test Notification 2',
    },
    {
        id: 2164260887,
        label: '帮助 > Debug > Test Notification 3',
        placement: 'MenuBar',
        name: 'Test Notification 3',
    },
    {
        id: 2164260889,
        label: '帮助 > Debug > Count Objects',
        placement: 'MenuBar',
        name: 'Count Objects',
    },
    {
        id: 2164260890,
        label: '帮助 > Debug > Object Counts',
        placement: 'MenuBar',
        name: 'Object Counts',
    },
    {
        id: 2164260892,
        label: '帮助 > Debug > Track API Refs',
        placement: 'MenuBar',
        name: 'Track API Refs',
    },
    {
        id: 2164260893,
        label: '帮助 > Debug > Process Deep Link',
        placement: 'MenuBar',
        name: 'Process Deep Link',
    },
    {
        id: 2164260894,
        label: '帮助 > Debug > Start Discover Panel Tour',
        placement: 'MenuBar',
        name: 'Start Discover Panel Tour',
    },
    {
        id: 2164260896,
        label: '帮助 > Debug > Enable New Rendering',
        placement: 'MenuBar',
        name: 'Enable New Rendering',
    },
    {
        id: 2164260897,
        label: '帮助 > Debug > Enable Rendering Timer',
        placement: 'MenuBar',
        name: 'Enable Rendering Timer',
    },
    {
        id: 2164260898,
        label: '帮助 > Debug > Purge Rendering Cache',
        placement: 'MenuBar',
        name: 'Purge Rendering Cache',
    },
    {
        id: 2164260899,
        label: '帮助 > Debug > Redraw',
        placement: 'MenuBar',
        name: 'Redraw',
    },
    {
        id: 2164260900,
        label: '帮助 > Debug > Dump Application Heap Used',
        placement: 'MenuBar',
        name: 'Dump Application Heap Used',
    },
    {
        id: 2164260901,
        label: '帮助 > Debug > Disable Greeking for New Rendering',
        placement: 'MenuBar',
        name: 'Disable Greeking for New Rendering',
    },
    {
        id: 2164260902,
        label: '帮助 > Debug > Enable Threaded Rendering',
        placement: 'MenuBar',
        name: 'Enable Threaded Rendering',
    },
    {
        id: 2164260903,
        label: '帮助 > Debug > Enable AGM Threading',
        placement: 'MenuBar',
        name: 'Enable AGM Threading',
    },
    {
        id: 2164260904,
        label: '帮助 > Debug > Enable AGM Internal Memory Pool',
        placement: 'MenuBar',
        name: 'Enable AGM Internal Memory Pool',
    },
    {
        id: 2164260905,
        label: '帮助 > Debug > Enable QuickPort Quartz',
        placement: 'MenuBar',
        name: 'Enable QuickPort Quartz',
    },
    {
        id: 2164260906,
        label: '帮助 > Debug > Crash',
        placement: 'MenuBar',
        name: 'Crash',
    },
    {
        id: 2164260908,
        label: '帮助 > Debug > Enable PGF Recovery',
        placement: 'MenuBar',
        name: 'Enable PGF Recovery',
    },
    {
        id: 2164260909,
        label: '帮助 > Debug > Enable ATE Read Recovery',
        placement: 'MenuBar',
        name: 'Enable ATE Read Recovery',
    },
    {
        id: 2164260910,
        label: '帮助 > Debug > Enable ATE Write Recovery',
        placement: 'MenuBar',
        name: 'Enable ATE Write Recovery',
    },
    {
        id: 2164260912,
        label: '窗口 > 信息',
        placement: 'MenuBar',
        name: '信息',
    },
    {
        id: 2164260914,
        label: '窗口 > 文字 > 字符',
        placement: 'MenuBar',
        name: '字符',
    },
    {
        id: 2164260915,
        label: '窗口 > 文字 > 段落',
        placement: 'MenuBar',
        name: '段落',
    },
    {
        id: 2164260916,
        label: '窗口 > 文字 > 制表符',
        placement: 'MenuBar',
        name: '制表符',
    },
    {
        id: 2164260917,
        label: '窗口 > 文字 > OpenType',
        placement: 'MenuBar',
        name: 'OpenType',
    },
    {
        id: 2164260918,
        label: '文字 > 标点挤压设置...',
        placement: 'MenuBar',
        name: '标点挤压设置...',
    },
    {
        id: 2164260919,
        label: '效果 > Photoshop 效果',
        placement: 'MenuBar',
        name: 'Photoshop 效果',
    },
    {
        id: 2164260922,
        label: '效果 > 模糊 > 特殊模糊...',
        placement: 'MenuBar',
        name: '特殊模糊...',
    },
    {
        id: 2164260923,
        label: '效果 > 模糊 > 径向模糊...',
        placement: 'MenuBar',
        name: '径向模糊...',
    },
    {
        id: 2164260925,
        label: '效果 > 像素化 > 点状化...',
        placement: 'MenuBar',
        name: '点状化...',
    },
    {
        id: 2164260926,
        label: '效果 > 像素化 > 铜版雕刻...',
        placement: 'MenuBar',
        name: '铜版雕刻...',
    },
    {
        id: 2164260928,
        label: '效果 > 视频 > 逐行...',
        placement: 'MenuBar',
        name: '逐行...',
    },
    {
        id: 2164260929,
        label: '效果 > 像素化 > 晶格化...',
        placement: 'MenuBar',
        name: '晶格化...',
    },
    {
        id: 2164260930,
        label: '效果 > 像素化 > 彩色半调...',
        placement: 'MenuBar',
        name: '彩色半调...',
    },
    {
        id: 2164260931,
        label: '效果 > 视频 > NTSC 颜色',
        placement: 'MenuBar',
        name: 'NTSC 颜色',
    },
    {
        id: 2164260933,
        label: '效果 > 艺术效果 > 水彩...',
        placement: 'MenuBar',
        name: '水彩...',
    },
    {
        id: 2164260935,
        label: '效果 > 素描 > 水彩画纸...',
        placement: 'MenuBar',
        name: '水彩画纸...',
    },
    {
        id: 2164260936,
        label: '效果 > 艺术效果 > 底纹效果...',
        placement: 'MenuBar',
        name: '底纹效果...',
    },
    {
        id: 2164260937,
        label: '效果 > 素描 > 撕边...',
        placement: 'MenuBar',
        name: '撕边...',
    },
    {
        id: 2164260939,
        label: '效果 > 纹理 > 纹理化...',
        placement: 'MenuBar',
        name: '纹理化...',
    },
    {
        id: 2164260941,
        label: '效果 > 画笔描边 > 烟灰墨...',
        placement: 'MenuBar',
        name: '烟灰墨...',
    },
    {
        id: 2164260942,
        label: '效果 > 素描 > 图章...',
        placement: 'MenuBar',
        name: '图章...',
    },
    {
        id: 2164260943,
        label: '效果 > 纹理 > 染色玻璃...',
        placement: 'MenuBar',
        name: '染色玻璃...',
    },
    {
        id: 2164260944,
        label: '效果 > 画笔描边 > 喷色描边...',
        placement: 'MenuBar',
        name: '喷色描边...',
    },
    {
        id: 2164260945,
        label: '效果 > 艺术效果 > 海绵...',
        placement: 'MenuBar',
        name: '海绵...',
    },
    {
        id: 2164260946,
        label: '效果 > 画笔描边 > 喷溅...',
        placement: 'MenuBar',
        name: '喷溅...',
    },
    {
        id: 2164260947,
        label: '效果 > 艺术效果 > 涂抹棒...',
        placement: 'MenuBar',
        name: '涂抹棒...',
    },
    {
        id: 2164260948,
        label: '效果 > 艺术效果 > 粗糙蜡笔...',
        placement: 'MenuBar',
        name: '粗糙蜡笔...',
    },
    {
        id: 2164260949,
        label: '效果 > 素描 > 网状...',
        placement: 'MenuBar',
        name: '网状...',
    },
    {
        id: 2164260950,
        label: '效果 > 艺术效果 > 海报边缘...',
        placement: 'MenuBar',
        name: '海报边缘...',
    },
    {
        id: 2164260951,
        label: '效果 > 艺术效果 > 塑料包装...',
        placement: 'MenuBar',
        name: '塑料包装...',
    },
    {
        id: 2164260952,
        label: '效果 > 素描 > 石膏效果...',
        placement: 'MenuBar',
        name: '石膏效果...',
    },
    {
        id: 2164260953,
        label: '效果 > 素描 > 影印...',
        placement: 'MenuBar',
        name: '影印...',
    },
    {
        id: 2164260954,
        label: '效果 > 纹理 > 拼缀图...',
        placement: 'MenuBar',
        name: '拼缀图...',
    },
    {
        id: 2164260955,
        label: '效果 > 艺术效果 > 调色刀...',
        placement: 'MenuBar',
        name: '调色刀...',
    },
    {
        id: 2164260956,
        label: '效果 > 艺术效果 > 绘画涂抹...',
        placement: 'MenuBar',
        name: '绘画涂抹...',
    },
    {
        id: 2164260958,
        label: '效果 > 扭曲 > 海洋波纹...',
        placement: 'MenuBar',
        name: '海洋波纹...',
    },
    {
        id: 2164260959,
        label: '效果 > 素描 > 便条纸...',
        placement: 'MenuBar',
        name: '便条纸...',
    },
    {
        id: 2164260960,
        label: '效果 > 艺术效果 > 霓虹灯光...',
        placement: 'MenuBar',
        name: '霓虹灯光...',
    },
    {
        id: 2164260961,
        label: '效果 > 纹理 > 马赛克拼贴...',
        placement: 'MenuBar',
        name: '马赛克拼贴...',
    },
    {
        id: 2164260962,
        label: '效果 > 画笔描边 > 墨水轮廓...',
        placement: 'MenuBar',
        name: '墨水轮廓...',
    },
    {
        id: 2164260963,
        label: '效果 > 素描 > 半调图案...',
        placement: 'MenuBar',
        name: '半调图案...',
    },
    {
        id: 2164260964,
        label: '效果 > 素描 > 绘图笔...',
        placement: 'MenuBar',
        name: '绘图笔...',
    },
    {
        id: 2164260965,
        label: '效果 > 纹理 > 颗粒...',
        placement: 'MenuBar',
        name: '颗粒...',
    },
    {
        id: 2164260967,
        label: '效果 > 风格化 > 照亮边缘...',
        placement: 'MenuBar',
        name: '照亮边缘...',
    },
    {
        id: 2164260968,
        label: '效果 > 扭曲 > 玻璃...',
        placement: 'MenuBar',
        name: '玻璃...',
    },
    {
        id: 2164260969,
        label: '效果 > 艺术效果 > 壁画...',
        placement: 'MenuBar',
        name: '壁画...',
    },
    {
        id: 2164260970,
        label: '效果 > 艺术效果 > 胶片颗粒...',
        placement: 'MenuBar',
        name: '胶片颗粒...',
    },
    {
        id: 2164260971,
        label: '效果 > 艺术效果 > 干画笔...',
        placement: 'MenuBar',
        name: '干画笔...',
    },
    {
        id: 2164260972,
        label: '效果 > 扭曲 > 扩散亮光...',
        placement: 'MenuBar',
        name: '扩散亮光...',
    },
    {
        id: 2164260973,
        label: '效果 > 画笔描边 > 深色线条...',
        placement: 'MenuBar',
        name: '深色线条...',
    },
    {
        id: 2164260974,
        label: '效果 > 艺术效果 > 木刻...',
        placement: 'MenuBar',
        name: '木刻...',
    },
    {
        id: 2164260975,
        label: '效果 > 画笔描边 > 阴影线...',
        placement: 'MenuBar',
        name: '阴影线...',
    },
    {
        id: 2164260976,
        label: '效果 > 纹理 > 龟裂缝...',
        placement: 'MenuBar',
        name: '龟裂缝...',
    },
    {
        id: 2164260977,
        label: '效果 > 素描 > 炭精笔...',
        placement: 'MenuBar',
        name: '炭精笔...',
    },
    {
        id: 2164260978,
        label: '效果 > 艺术效果 > 彩色铅笔...',
        placement: 'MenuBar',
        name: '彩色铅笔...',
    },
    {
        id: 2164260979,
        label: '效果 > 素描 > 铬黄...',
        placement: 'MenuBar',
        name: '铬黄...',
    },
    {
        id: 2164260980,
        label: '效果 > 素描 > 炭笔...',
        placement: 'MenuBar',
        name: '炭笔...',
    },
    {
        id: 2164260981,
        label: '效果 > 素描 > 粉笔和炭笔...',
        placement: 'MenuBar',
        name: '粉笔和炭笔...',
    },
    {
        id: 2164260982,
        label: '效果 > 素描 > 基底凸现...',
        placement: 'MenuBar',
        name: '基底凸现...',
    },
    {
        id: 2164260983,
        label: '效果 > 画笔描边 > 成角的线条...',
        placement: 'MenuBar',
        name: '成角的线条...',
    },
    {
        id: 2164260984,
        label: '效果 > 画笔描边 > 强化的边缘...',
        placement: 'MenuBar',
        name: '强化的边缘...',
    },
    {
        id: 2164260985,
        label: '效果 > 效果画廊...',
        placement: 'MenuBar',
        name: '效果画廊...',
    },
    {
        id: 2164260986,
        label: '编辑 > 编辑自定词典...',
        placement: 'MenuBar',
        name: '编辑自定词典...',
    },
    {
        id: 2164260989,
        label: '对象 > 路径 > 分割为网格...',
        placement: 'MenuBar',
        name: '分割为网格...',
    },
    {
        id: 2164260991,
        label: '文字 > 更改大小写 > 大写',
        placement: 'MenuBar',
        name: '大写',
    },
    {
        id: 2164260992,
        label: '文字 > 更改大小写 > 小写',
        placement: 'MenuBar',
        name: '小写',
    },
    {
        id: 2164260993,
        label: '文字 > 更改大小写 > 词首大写',
        placement: 'MenuBar',
        name: '词首大写',
    },
    {
        id: 2164260994,
        label: '文字 > 更改大小写 > 句首大写',
        placement: 'MenuBar',
        name: '句首大写',
    },
    {
        id: 2164260995,
        label: '文字 > 视觉边距对齐方式',
        placement: 'MenuBar',
        name: '视觉边距对齐方式',
    },
    {
        id: 2164260996,
        label: '文字 > 查找/替换字体...',
        placement: 'MenuBar',
        name: '查找/替换字体...',
    },
    {
        id: 2164260997,
        label: '文字 > 智能标点...',
        placement: 'MenuBar',
        name: '智能标点...',
    },
    {
        id: 2164260998,
        label: '效果 > Illustrator 效果',
        placement: 'MenuBar',
        name: 'Illustrator 效果',
    },
    {
        id: 2164261001,
        label: '效果 > 扭曲和变换 > 变换...',
        placement: 'MenuBar',
        name: '变换...',
    },
    {
        id: 2164261002,
        label: '对象 > 变换 > 分别变换...',
        placement: 'MenuBar',
        name: '分别变换...',
    },
    {
        id: 2164261004,
        label: '窗口 > 库',
        placement: 'MenuBar',
        name: '库',
    },
    {
        id: 2164261006,
        label: '窗口 > 查找有关 Exchange 的扩展功能...',
        placement: 'MenuBar',
        name: '查找有关 Exchange 的扩展功能...',
    },
    {
        id: 2164261007,
        label: '对象 > 创建渐变网格...',
        placement: 'MenuBar',
        name: '创建渐变网格...',
    },
    {
        id: 2164261008,
        label: '窗口 > 分色预览',
        placement: 'MenuBar',
        name: '分色预览',
    },
    {
        id: 2164261009,
        label: '窗口 > 链接',
        placement: 'MenuBar',
        name: '链接',
    },
    {
        id: 2164261011,
        label: '编辑 > 编辑原稿',
        placement: 'MenuBar',
        name: '编辑原稿',
    },
    {
        id: 2164261013,
        label: '窗口 > 文字 > 段落样式',
        placement: 'MenuBar',
        name: '段落样式',
    },
    {
        id: 2164261014,
        label: '窗口 > 文字 > 字符样式',
        placement: 'MenuBar',
        name: '字符样式',
    },
    {
        id: 2164261015,
        label: '窗口 > 画板',
        placement: 'MenuBar',
        name: '画板',
    },
    {
        id: 2164261017,
        label: '对象 > 画板 > 重新排列所有画板',
        placement: 'MenuBar',
        name: '重新排列所有画板',
    },
    {
        id: 2164261019,
        label: '对象 > 画板 > 适合图稿边界',
        placement: 'MenuBar',
        name: '适合图稿边界',
    },
    {
        id: 2164261020,
        label: '对象 > 画板 > 适合选中的图稿',
        placement: 'MenuBar',
        name: '适合选中的图稿',
    },
    {
        id: 2164261021,
        label: '窗口 > 属性',
        placement: 'MenuBar',
        name: '属性',
    },
    {
        id: 2164261022,
        label: '窗口 > 导航器',
        placement: 'MenuBar',
        name: '导航器',
    },
    {
        id: 2164261025,
        label: '窗口 > 工作区 > 重置Getting Started',
        placement: 'MenuBar',
        name: '重置Getting Started',
    },
    {
        id: 2164261026,
        label: '窗口 > 工作区 > 新建工作区...',
        placement: 'MenuBar',
        name: '新建工作区...',
    },
    {
        id: 2164261027,
        label: '窗口 > 工作区 > 管理工作区...',
        placement: 'MenuBar',
        name: '管理工作区...',
    },
    {
        id: 2164261028,
        label: '窗口 > 工作区 > 排版规则',
        placement: 'MenuBar',
        name: '排版规则',
    },
    {
        id: 2164261029,
        label: '窗口 > 工作区 > Getting Started',
        placement: 'MenuBar',
        name: 'Getting Started',
    },
    {
        id: 2164261030,
        label: '窗口 > 工作区 > 描摹',
        placement: 'MenuBar',
        name: '描摹',
    },
    {
        id: 2164261031,
        label: '窗口 > 工作区 > 打印和校样',
        placement: 'MenuBar',
        name: '打印和校样',
    },
    {
        id: 2164261032,
        label: '窗口 > 工作区 > 基本功能',
        placement: 'MenuBar',
        name: '基本功能',
    },
    {
        id: 2164261033,
        label: '窗口 > 工作区 > 版面',
        placement: 'MenuBar',
        name: '版面',
    },
    {
        id: 2164261034,
        label: '窗口 > 工作区 > 自动',
        placement: 'MenuBar',
        name: '自动',
    },
    {
        id: 2164261035,
        label: '窗口 > 工作区 > Web',
        placement: 'MenuBar',
        name: 'Web',
    },
    {
        id: 2164261036,
        label: '窗口 > 工作区 > 上色',
        placement: 'MenuBar',
        name: '上色',
    },
    {
        id: 2164261037,
        label: '窗口 > 工作区 > 传统基本功能',
        placement: 'MenuBar',
        name: '传统基本功能',
    },
    {
        id: 2164261038,
        label: '文字 > 避头尾法则设置...',
        placement: 'MenuBar',
        name: '避头尾法则设置...',
    },
    {
        id: 2164261039,
        label: '编辑 > 键盘快捷键...',
        placement: 'MenuBar',
        name: '键盘快捷键...',
    },
    {
        id: 2164261040,
        label: '窗口 > 图形样式',
        placement: 'MenuBar',
        name: '图形样式',
    },
    {
        id: 2164261041,
        label: '窗口 > 外观',
        placement: 'MenuBar',
        name: '外观',
    },
    {
        id: 2164261047,
        label: '窗口 > 图形样式库 > 3D 效果',
        placement: 'MenuBar',
        name: '3D 效果',
    },
    {
        id: 2164261048,
        label: '窗口 > 图形样式库 > Vonster 图案样式',
        placement: 'MenuBar',
        name: 'Vonster 图案样式',
    },
    {
        id: 2164261049,
        label: '窗口 > 图形样式库 > 图像效果',
        placement: 'MenuBar',
        name: '图像效果',
    },
    {
        id: 2164261050,
        label: '窗口 > 图形样式库 > 按钮和翻转效果',
        placement: 'MenuBar',
        name: '按钮和翻转效果',
    },
    {
        id: 2164261051,
        label: '窗口 > 图形样式库 > 文字效果',
        placement: 'MenuBar',
        name: '文字效果',
    },
    {
        id: 2164261052,
        label: '窗口 > 图形样式库 > 斑点画笔的附属品',
        placement: 'MenuBar',
        name: '斑点画笔的附属品',
    },
    {
        id: 2164261053,
        label: '窗口 > 图形样式库 > 涂抹效果',
        placement: 'MenuBar',
        name: '涂抹效果',
    },
    {
        id: 2164261054,
        label: '窗口 > 图形样式库 > 照亮样式',
        placement: 'MenuBar',
        name: '照亮样式',
    },
    {
        id: 2164261055,
        label: '窗口 > 图形样式库 > 纹理',
        placement: 'MenuBar',
        name: '纹理',
    },
    {
        id: 2164261056,
        label: '窗口 > 图形样式库 > 艺术效果',
        placement: 'MenuBar',
        name: '艺术效果',
    },
    {
        id: 2164261057,
        label: '窗口 > 图形样式库 > 附属品',
        placement: 'MenuBar',
        name: '附属品',
    },
    {
        id: 2164261058,
        label: '窗口 > 图形样式库 > 霓虹效果',
        placement: 'MenuBar',
        name: '霓虹效果',
    },
    {
        id: 2164261061,
        label: '窗口 > 图形样式库 > 其它库...',
        placement: 'MenuBar',
        name: '其它库...',
    },
    {
        id: 2164261062,
        label: '窗口 > 符号',
        placement: 'MenuBar',
        name: '符号',
    },
    {
        id: 2164261064,
        label: '窗口 > 符号库 > 3D 符号',
        placement: 'MenuBar',
        name: '3D 符号',
    },
    {
        id: 2164261065,
        label: '窗口 > 符号库 > Web 按钮和条形',
        placement: 'MenuBar',
        name: 'Web 按钮和条形',
    },
    {
        id: 2164261066,
        label: '窗口 > 符号库 > 传家宝',
        placement: 'MenuBar',
        name: '传家宝',
    },
    {
        id: 2164261067,
        label: '窗口 > 符号库 > 原始',
        placement: 'MenuBar',
        name: '原始',
    },
    {
        id: 2164261068,
        label: '窗口 > 符号库 > 图表',
        placement: 'MenuBar',
        name: '图表',
    },
    {
        id: 2164261069,
        label: '窗口 > 符号库 > 地图',
        placement: 'MenuBar',
        name: '地图',
    },
    {
        id: 2164261070,
        label: '窗口 > 符号库 > 复古',
        placement: 'MenuBar',
        name: '复古',
    },
    {
        id: 2164261071,
        label: '窗口 > 符号库 > 寿司',
        placement: 'MenuBar',
        name: '寿司',
    },
    {
        id: 2164261072,
        label: '窗口 > 符号库 > 庆祝',
        placement: 'MenuBar',
        name: '庆祝',
    },
    {
        id: 2164261073,
        label: '窗口 > 符号库 > 徽标元素',
        placement: 'MenuBar',
        name: '徽标元素',
    },
    {
        id: 2164261074,
        label: '窗口 > 符号库 > 提基',
        placement: 'MenuBar',
        name: '提基',
    },
    {
        id: 2164261075,
        label: '窗口 > 符号库 > 时尚',
        placement: 'MenuBar',
        name: '时尚',
    },
    {
        id: 2164261076,
        label: '窗口 > 符号库 > 毛发和毛皮',
        placement: 'MenuBar',
        name: '毛发和毛皮',
    },
    {
        id: 2164261077,
        label: '窗口 > 符号库 > 污点矢量包',
        placement: 'MenuBar',
        name: '污点矢量包',
    },
    {
        id: 2164261078,
        label: '窗口 > 符号库 > 点状图案矢量包',
        placement: 'MenuBar',
        name: '点状图案矢量包',
    },
    {
        id: 2164261079,
        label: '窗口 > 符号库 > 照亮丝带',
        placement: 'MenuBar',
        name: '照亮丝带',
    },
    {
        id: 2164261080,
        label: '窗口 > 符号库 > 照亮流程图',
        placement: 'MenuBar',
        name: '照亮流程图',
    },
    {
        id: 2164261081,
        label: '窗口 > 符号库 > 照亮组织结构图',
        placement: 'MenuBar',
        name: '照亮组织结构图',
    },
    {
        id: 2164261082,
        label: '窗口 > 符号库 > 疯狂科学',
        placement: 'MenuBar',
        name: '疯狂科学',
    },
    {
        id: 2164261083,
        label: '窗口 > 符号库 > 移动',
        placement: 'MenuBar',
        name: '移动',
    },
    {
        id: 2164261084,
        label: '窗口 > 符号库 > 箭头',
        placement: 'MenuBar',
        name: '箭头',
    },
    {
        id: 2164261085,
        label: '窗口 > 符号库 > 绚丽矢量包',
        placement: 'MenuBar',
        name: '绚丽矢量包',
    },
    {
        id: 2164261086,
        label: '窗口 > 符号库 > 网页图标',
        placement: 'MenuBar',
        name: '网页图标',
    },
    {
        id: 2164261087,
        label: '窗口 > 符号库 > 自然',
        placement: 'MenuBar',
        name: '自然',
    },
    {
        id: 2164261088,
        label: '窗口 > 符号库 > 至尊矢量包',
        placement: 'MenuBar',
        name: '至尊矢量包',
    },
    {
        id: 2164261089,
        label: '窗口 > 符号库 > 艺术纹理',
        placement: 'MenuBar',
        name: '艺术纹理',
    },
    {
        id: 2164261090,
        label: '窗口 > 符号库 > 花朵',
        placement: 'MenuBar',
        name: '花朵',
    },
    {
        id: 2164261091,
        label: '窗口 > 符号库 > 通讯',
        placement: 'MenuBar',
        name: '通讯',
    },
    {
        id: 2164261094,
        label: '窗口 > 符号库 > 其它库...',
        placement: 'MenuBar',
        name: '其它库...',
    },
    {
        id: 2164261096,
        label: '视图 > 智能参考线',
        placement: 'MenuBar',
        name: '智能参考线',
    },
    {
        id: 2164261097,
        label: '窗口 > 拼合器预览',
        placement: 'MenuBar',
        name: '拼合器预览',
    },
    {
        id: 2164261098,
        label: '窗口 > 历史记录',
        placement: 'MenuBar',
        name: '历史记录',
    },
    {
        id: 2164261100,
        label: '文字 > 字形',
        placement: 'MenuBar',
        name: '字形',
    },
    {
        id: 2164261101,
        label: '窗口 > 文字 > 字形',
        placement: 'MenuBar',
        name: '字形',
    },
    {
        id: 2164261102,
        label: '窗口 > 动作',
        placement: 'MenuBar',
        name: '动作',
    },
    {
        id: 2164261104,
        label: '选择 > 反向',
        placement: 'MenuBar',
        name: '反向',
    },
    {
        id: 2164261106,
        label: '效果 > 风格化 > 投影...',
        placement: 'MenuBar',
        name: '投影...',
    },
    {
        id: 2164261107,
        label: '效果 > 风格化 > 外发光...',
        placement: 'MenuBar',
        name: '外发光...',
    },
    {
        id: 2164261108,
        label: '效果 > 风格化 > 内发光...',
        placement: 'MenuBar',
        name: '内发光...',
    },
    {
        id: 2164261110,
        label: '效果 > 转换为形状 > 矩形...',
        placement: 'MenuBar',
        name: '矩形...',
    },
    {
        id: 2164261111,
        label: '效果 > 转换为形状 > 圆角矩形...',
        placement: 'MenuBar',
        name: '圆角矩形...',
    },
    {
        id: 2164261112,
        label: '效果 > 转换为形状 > 椭圆...',
        placement: 'MenuBar',
        name: '椭圆...',
    },
    {
        id: 2164261113,
        label: '效果 > 风格化 > 圆角...',
        placement: 'MenuBar',
        name: '圆角...',
    },
    {
        id: 2164261115,
        label: '对象 > 路径 > 清理...',
        placement: 'MenuBar',
        name: '清理...',
    },
    {
        id: 2164261117,
        label: '编辑 > 编辑颜色 > 叠印黑色...',
        placement: 'MenuBar',
        name: '叠印黑色...',
    },
    {
        id: 2164261118,
        label: '效果 > 扭曲和变换 > 自由扭曲...',
        placement: 'MenuBar',
        name: '自由扭曲...',
    },
    {
        id: 2164261119,
        label: '效果 > 扭曲和变换 > 收缩和膨胀...',
        placement: 'MenuBar',
        name: '收缩和膨胀...',
    },
    {
        id: 2164261121,
        label: '对象 > 文本绕排 > 建立',
        placement: 'MenuBar',
        name: '建立',
    },
    {
        id: 2164261122,
        label: '对象 > 文本绕排 > 释放',
        placement: 'MenuBar',
        name: '释放',
    },
    {
        id: 2164261124,
        label: '对象 > 文本绕排 > 文本绕排选项...',
        placement: 'MenuBar',
        name: '文本绕排选项...',
    },
    {
        id: 2164261125,
        label: '效果 > 扭曲和变换 > 扭拧...',
        placement: 'MenuBar',
        name: '扭拧...',
    },
    {
        id: 2164261126,
        label: '选择 > 对象 > 剪切蒙版',
        placement: 'MenuBar',
        name: '剪切蒙版',
    },
    {
        id: 2164261127,
        label: '编辑 > 编辑颜色 > 前后混合',
        placement: 'MenuBar',
        name: '前后混合',
    },
    {
        id: 2164261128,
        label: '编辑 > 编辑颜色 > 水平混合',
        placement: 'MenuBar',
        name: '水平混合',
    },
    {
        id: 2164261129,
        label: '编辑 > 编辑颜色 > 垂直混合',
        placement: 'MenuBar',
        name: '垂直混合',
    },
    {
        id: 2164261130,
        label: '编辑 > 编辑颜色 > 反相颜色',
        placement: 'MenuBar',
        name: '反相颜色',
    },
    {
        id: 2164261131,
        label: '编辑 > 编辑颜色 > 转换为灰度',
        placement: 'MenuBar',
        name: '转换为灰度',
    },
    {
        id: 2164261132,
        label: '编辑 > 编辑颜色 > 转换为 CMYK',
        placement: 'MenuBar',
        name: '转换为 CMYK',
    },
    {
        id: 2164261133,
        label: '编辑 > 编辑颜色 > 转换为 RGB',
        placement: 'MenuBar',
        name: '转换为 RGB',
    },
    {
        id: 2164261134,
        label: '编辑 > 编辑颜色 > 调整饱和度...',
        placement: 'MenuBar',
        name: '调整饱和度...',
    },
    {
        id: 2164261136,
        label: '对象 > 路径 > 添加锚点',
        placement: 'MenuBar',
        name: '添加锚点',
    },
    {
        id: 2164261137,
        label: '编辑 > 编辑颜色 > 调整色彩平衡...',
        placement: 'MenuBar',
        name: '调整色彩平衡...',
    },
    {
        id: 2164261138,
        label: '对象 > 创建对象马赛克...',
        placement: 'MenuBar',
        name: '创建对象马赛克...',
    },
    {
        id: 2164261139,
        label: '效果 > 扭曲和变换 > 粗糙化...',
        placement: 'MenuBar',
        name: '粗糙化...',
    },
    {
        id: 2164261140,
        label: '选择 > 重新选择',
        placement: 'MenuBar',
        name: '重新选择',
    },
    {
        id: 2164261142,
        label: '选择 > 相同 > 形状和文本',
        placement: 'MenuBar',
        name: '形状和文本',
    },
    {
        id: 2164261143,
        label: '选择 > 相同 > 文本',
        placement: 'MenuBar',
        name: '文本',
    },
    {
        id: 2164261145,
        label: '选择 > 相同 > 填充颜色',
        placement: 'MenuBar',
        name: '填充颜色',
    },
    {
        id: 2164261146,
        label: '选择 > 相同 > 图形样式',
        placement: 'MenuBar',
        name: '图形样式',
    },
    {
        id: 2164261147,
        label: '选择 > 相同 > 填色和描边',
        placement: 'MenuBar',
        name: '填色和描边',
    },
    {
        id: 2164261148,
        label: '选择 > 相同 > 描边颜色',
        placement: 'MenuBar',
        name: '描边颜色',
    },
    {
        id: 2164261149,
        label: '选择 > 相同 > 描边粗细',
        placement: 'MenuBar',
        name: '描边粗细',
    },
    {
        id: 2164261150,
        label: '选择 > 相同 > 混合模式',
        placement: 'MenuBar',
        name: '混合模式',
    },
    {
        id: 2164261151,
        label: '选择 > 相同 > 不透明度',
        placement: 'MenuBar',
        name: '不透明度',
    },
    {
        id: 2164261152,
        label: '选择 > 相同 > 形状',
        placement: 'MenuBar',
        name: '形状',
    },
    {
        id: 2164261153,
        label: '选择 > 相同 > 符号实例',
        placement: 'MenuBar',
        name: '符号实例',
    },
    {
        id: 2164261154,
        label: '选择 > 相同 > 链接块系列',
        placement: 'MenuBar',
        name: '链接块系列',
    },
    {
        id: 2164261155,
        label: '选择 > 相同 > 外观',
        placement: 'MenuBar',
        name: '外观',
    },
    {
        id: 2164261156,
        label: '选择 > 相同 > 外观属性',
        placement: 'MenuBar',
        name: '外观属性',
    },
    {
        id: 2164261157,
        label: '选择 > 相同 > 文本填充颜色',
        placement: 'MenuBar',
        name: '文本填充颜色',
    },
    {
        id: 2164261158,
        label: '选择 > 相同 > 文本描边颜色',
        placement: 'MenuBar',
        name: '文本描边颜色',
    },
    {
        id: 2164261159,
        label: '选择 > 相同 > 文本填充和描边颜色',
        placement: 'MenuBar',
        name: '文本填充和描边颜色',
    },
    {
        id: 2164261160,
        label: '选择 > 相同 > 字体大小',
        placement: 'MenuBar',
        name: '字体大小',
    },
    {
        id: 2164261161,
        label: '选择 > 相同 > 字体系列',
        placement: 'MenuBar',
        name: '字体系列',
    },
    {
        id: 2164261162,
        label: '选择 > 相同 > 字体系列和样式',
        placement: 'MenuBar',
        name: '字体系列和样式',
    },
    {
        id: 2164261163,
        label: '选择 > 相同 > 字体系列、样式和大小',
        placement: 'MenuBar',
        name: '字体系列、样式和大小',
    },
    {
        id: 2164261164,
        label: '选择 > 对象 > 游离点',
        placement: 'MenuBar',
        name: '游离点',
    },
    {
        id: 2164261166,
        label: '选择 > 对象 > 所有文本对象',
        placement: 'MenuBar',
        name: '所有文本对象',
    },
    {
        id: 2164261167,
        label: '选择 > 对象 > 点状文字对象',
        placement: 'MenuBar',
        name: '点状文字对象',
    },
    {
        id: 2164261168,
        label: '选择 > 对象 > 区域文字对象',
        placement: 'MenuBar',
        name: '区域文字对象',
    },
    {
        id: 2164261169,
        label: '效果 > 扭曲和变换 > 波纹效果...',
        placement: 'MenuBar',
        name: '波纹效果...',
    },
    {
        id: 2164261170,
        label: '效果 > 裁剪标记',
        placement: 'MenuBar',
        name: '裁剪标记',
    },
    {
        id: 2164261171,
        label: '对象 > 创建裁切标记',
        placement: 'MenuBar',
        name: '创建裁切标记',
    },
    {
        id: 2164261172,
        label: '文件 > 打包...',
        placement: 'MenuBar',
        name: '打包...',
    },
    {
        id: 2164261173,
        label: '窗口 > 图层',
        placement: 'MenuBar',
        name: '图层',
    },
    {
        id: 2164261176,
        label: '文件 > 在 Bridge 中浏览...',
        placement: 'MenuBar',
        name: '在 Bridge 中浏览...',
    },
    {
        id: 2164261177,
        label: '文件 > 文件信息...',
        placement: 'MenuBar',
        name: '文件信息...',
    },
    {
        id: 2164261178,
        label: '窗口 > 文档信息',
        placement: 'MenuBar',
        name: '文档信息',
    },
    {
        id: 2164261180,
        label: '效果 > 路径查找器 > 相加',
        placement: 'MenuBar',
        name: '相加',
    },
    {
        id: 2164261181,
        label: '效果 > 路径查找器 > 交集',
        placement: 'MenuBar',
        name: '交集',
    },
    {
        id: 2164261182,
        label: '效果 > 路径查找器 > 差集',
        placement: 'MenuBar',
        name: '差集',
    },
    {
        id: 2164261183,
        label: '效果 > 路径查找器 > 相减',
        placement: 'MenuBar',
        name: '相减',
    },
    {
        id: 2164261184,
        label: '效果 > 路径查找器 > 减去后方对象',
        placement: 'MenuBar',
        name: '减去后方对象',
    },
    {
        id: 2164261185,
        label: '效果 > 路径查找器 > 分割',
        placement: 'MenuBar',
        name: '分割',
    },
    {
        id: 2164261186,
        label: '效果 > 路径查找器 > 修边',
        placement: 'MenuBar',
        name: '修边',
    },
    {
        id: 2164261187,
        label: '效果 > 路径查找器 > 合并',
        placement: 'MenuBar',
        name: '合并',
    },
    {
        id: 2164261188,
        label: '效果 > 路径查找器 > 裁剪',
        placement: 'MenuBar',
        name: '裁剪',
    },
    {
        id: 2164261189,
        label: '效果 > 路径查找器 > 轮廓',
        placement: 'MenuBar',
        name: '轮廓',
    },
    {
        id: 2164261190,
        label: '效果 > 路径查找器 > 实色混合',
        placement: 'MenuBar',
        name: '实色混合',
    },
    {
        id: 2164261191,
        label: '效果 > 路径查找器 > 透明混合...',
        placement: 'MenuBar',
        name: '透明混合...',
    },
    {
        id: 2164261192,
        label: '效果 > 路径查找器 > 陷印...',
        placement: 'MenuBar',
        name: '陷印...',
    },
    {
        id: 2164261193,
        label: '视图 > 显示实时上色间隙',
        placement: 'MenuBar',
        name: '显示实时上色间隙',
    },
    {
        id: 2164261196,
        label: '对象 > 实时上色 > 建立',
        placement: 'MenuBar',
        name: '建立',
    },
    {
        id: 2164261197,
        label: '对象 > 实时上色 > 合并',
        placement: 'MenuBar',
        name: '合并',
    },
    {
        id: 2164261198,
        label: '对象 > 实时上色 > 释放',
        placement: 'MenuBar',
        name: '释放',
    },
    {
        id: 2164261200,
        label: '对象 > 实时上色 > 间隙选项...',
        placement: 'MenuBar',
        name: '间隙选项...',
    },
    {
        id: 2164261202,
        label: '对象 > 实时上色 > 扩展',
        placement: 'MenuBar',
        name: '扩展',
    },
    {
        id: 2164261203,
        label: '效果 > 风格化 > 涂抹...',
        placement: 'MenuBar',
        name: '涂抹...',
    },
    {
        id: 2164261205,
        label: '对象 > 封套扭曲 > 用变形建立...',
        placement: 'MenuBar',
        name: '用变形建立...',
    },
    {
        id: 2164261206,
        label: '对象 > 封套扭曲 > 用网格建立...',
        placement: 'MenuBar',
        name: '用网格建立...',
    },
    {
        id: 2164261207,
        label: '对象 > 封套扭曲 > 用顶层对象建立',
        placement: 'MenuBar',
        name: '用顶层对象建立',
    },
    {
        id: 2164261208,
        label: '对象 > 封套扭曲 > 释放',
        placement: 'MenuBar',
        name: '释放',
    },
    {
        id: 2164261210,
        label: '对象 > 封套扭曲 > 封套选项...',
        placement: 'MenuBar',
        name: '封套选项...',
    },
    {
        id: 2164261212,
        label: '对象 > 封套扭曲 > 扩展',
        placement: 'MenuBar',
        name: '扩展',
    },
    {
        id: 2164261214,
        label: '对象 > 封套扭曲 > 编辑内容',
        placement: 'MenuBar',
        name: '编辑内容',
    },
    {
        id: 2164261216,
        label: '效果 > 变形 > 弧形...',
        placement: 'MenuBar',
        name: '弧形...',
    },
    {
        id: 2164261217,
        label: '效果 > 变形 > 下弧形...',
        placement: 'MenuBar',
        name: '下弧形...',
    },
    {
        id: 2164261218,
        label: '效果 > 变形 > 上弧形...',
        placement: 'MenuBar',
        name: '上弧形...',
    },
    {
        id: 2164261219,
        label: '效果 > 变形 > 拱形...',
        placement: 'MenuBar',
        name: '拱形...',
    },
    {
        id: 2164261220,
        label: '效果 > 变形 > 凸出...',
        placement: 'MenuBar',
        name: '凸出...',
    },
    {
        id: 2164261221,
        label: '效果 > 变形 > 凹壳...',
        placement: 'MenuBar',
        name: '凹壳...',
    },
    {
        id: 2164261222,
        label: '效果 > 变形 > 凸壳...',
        placement: 'MenuBar',
        name: '凸壳...',
    },
    {
        id: 2164261223,
        label: '效果 > 变形 > 旗形...',
        placement: 'MenuBar',
        name: '旗形...',
    },
    {
        id: 2164261224,
        label: '效果 > 变形 > 波形...',
        placement: 'MenuBar',
        name: '波形...',
    },
    {
        id: 2164261225,
        label: '效果 > 变形 > 鱼形...',
        placement: 'MenuBar',
        name: '鱼形...',
    },
    {
        id: 2164261226,
        label: '效果 > 变形 > 上升...',
        placement: 'MenuBar',
        name: '上升...',
    },
    {
        id: 2164261227,
        label: '效果 > 变形 > 鱼眼...',
        placement: 'MenuBar',
        name: '鱼眼...',
    },
    {
        id: 2164261228,
        label: '效果 > 变形 > 膨胀...',
        placement: 'MenuBar',
        name: '膨胀...',
    },
    {
        id: 2164261229,
        label: '效果 > 变形 > 挤压...',
        placement: 'MenuBar',
        name: '挤压...',
    },
    {
        id: 2164261230,
        label: '效果 > 变形 > 扭转...',
        placement: 'MenuBar',
        name: '扭转...',
    },
    {
        id: 2164261231,
        label: '对象 > 扩展...',
        placement: 'MenuBar',
        name: '扩展...',
    },
    {
        id: 2164261233,
        label: '编辑 > 拼写检查 > 自动拼写检查',
        placement: 'MenuBar',
        name: '自动拼写检查',
    },
    {
        id: 2164261234,
        label: '编辑 > 拼写检查 > 拼写检查...',
        placement: 'MenuBar',
        name: '拼写检查...',
    },
    {
        id: 2164261235,
        label: '选择 > 启动全局编辑',
        placement: 'MenuBar',
        name: '启动全局编辑',
    },
    {
        id: 2164261236,
        label: 'Illustrator > 首选项 > 性能...',
        placement: 'MenuBar',
        name: '性能...',
    },
    {
        id: 2164261237,
        label: 'Illustrator > 首选项 > 文件处理...',
        placement: 'MenuBar',
        name: '文件处理...',
    },
    {
        id: 2164261238,
        label: 'Illustrator > 首选项 > 剪贴板处理...',
        placement: 'MenuBar',
        name: '剪贴板处理...',
    },
    {
        id: 2164261239,
        label: 'Illustrator > 首选项 > 黑色外观...',
        placement: 'MenuBar',
        name: '黑色外观...',
    },
    {
        id: 2164261240,
        label: 'Illustrator > 首选项 > 设备...',
        placement: 'MenuBar',
        name: '设备...',
    },
    {
        id: 2164261241,
        label: '窗口 > 画笔',
        placement: 'MenuBar',
        name: '画笔',
    },
    {
        id: 2164261242,
        label: '选择 > 对象 > 画笔描边',
        placement: 'MenuBar',
        name: '画笔描边',
    },
    {
        id: 2164261245,
        label: '窗口 > 画笔库 > Wacom 6D 画笔 > 6d 艺术钢笔画笔',
        placement: 'MenuBar',
        name: '6d 艺术钢笔画笔',
    },
    {
        id: 2164261247,
        label: '窗口 > 画笔库 > 图像画笔 > 图像画笔库',
        placement: 'MenuBar',
        name: '图像画笔库',
    },
    {
        id: 2164261249,
        label: '窗口 > 画笔库 > 毛刷画笔 > 毛刷画笔库',
        placement: 'MenuBar',
        name: '毛刷画笔库',
    },
    {
        id: 2164261251,
        label: '窗口 > 画笔库 > 矢量包 > 手绘画笔矢量包',
        placement: 'MenuBar',
        name: '手绘画笔矢量包',
    },
    {
        id: 2164261252,
        label: '窗口 > 画笔库 > 矢量包 > 颓废画笔矢量包',
        placement: 'MenuBar',
        name: '颓废画笔矢量包',
    },
    {
        id: 2164261254,
        label: '窗口 > 画笔库 > 箭头 > 图案箭头',
        placement: 'MenuBar',
        name: '图案箭头',
    },
    {
        id: 2164261255,
        label: '窗口 > 画笔库 > 箭头 > 箭头_标准',
        placement: 'MenuBar',
        name: '箭头_标准',
    },
    {
        id: 2164261256,
        label: '窗口 > 画笔库 > 箭头 > 箭头_特殊',
        placement: 'MenuBar',
        name: '箭头_特殊',
    },
    {
        id: 2164261258,
        label: '窗口 > 画笔库 > 艺术效果 > 艺术效果_书法',
        placement: 'MenuBar',
        name: '艺术效果_书法',
    },
    {
        id: 2164261259,
        label: '窗口 > 画笔库 > 艺术效果 > 艺术效果_卷轴笔',
        placement: 'MenuBar',
        name: '艺术效果_卷轴笔',
    },
    {
        id: 2164261260,
        label: '窗口 > 画笔库 > 艺术效果 > 艺术效果_水彩',
        placement: 'MenuBar',
        name: '艺术效果_水彩',
    },
    {
        id: 2164261261,
        label: '窗口 > 画笔库 > 艺术效果 > 艺术效果_油墨',
        placement: 'MenuBar',
        name: '艺术效果_油墨',
    },
    {
        id: 2164261262,
        label: '窗口 > 画笔库 > 艺术效果 > 艺术效果_画笔',
        placement: 'MenuBar',
        name: '艺术效果_画笔',
    },
    {
        id: 2164261263,
        label: '窗口 > 画笔库 > 艺术效果 > 艺术效果_粉笔炭笔铅笔',
        placement: 'MenuBar',
        name: '艺术效果_粉笔炭笔铅笔',
    },
    {
        id: 2164261265,
        label: '窗口 > 画笔库 > 装饰 > 典雅的卷曲和花形画笔组',
        placement: 'MenuBar',
        name: '典雅的卷曲和花形画笔组',
    },
    {
        id: 2164261266,
        label: '窗口 > 画笔库 > 装饰 > 装饰_散布',
        placement: 'MenuBar',
        name: '装饰_散布',
    },
    {
        id: 2164261267,
        label: '窗口 > 画笔库 > 装饰 > 装饰_文本分隔线',
        placement: 'MenuBar',
        name: '装饰_文本分隔线',
    },
    {
        id: 2164261268,
        label: '窗口 > 画笔库 > 装饰 > 装饰_横幅和封条',
        placement: 'MenuBar',
        name: '装饰_横幅和封条',
    },
    {
        id: 2164261270,
        label: '窗口 > 画笔库 > 边框 > 边框_几何图形',
        placement: 'MenuBar',
        name: '边框_几何图形',
    },
    {
        id: 2164261271,
        label: '窗口 > 画笔库 > 边框 > 边框_原始',
        placement: 'MenuBar',
        name: '边框_原始',
    },
    {
        id: 2164261272,
        label: '窗口 > 画笔库 > 边框 > 边框_新奇',
        placement: 'MenuBar',
        name: '边框_新奇',
    },
    {
        id: 2164261273,
        label: '窗口 > 画笔库 > 边框 > 边框_框架',
        placement: 'MenuBar',
        name: '边框_框架',
    },
    {
        id: 2164261274,
        label: '窗口 > 画笔库 > 边框 > 边框_线条',
        placement: 'MenuBar',
        name: '边框_线条',
    },
    {
        id: 2164261275,
        label: '窗口 > 画笔库 > 边框 > 边框_虚线',
        placement: 'MenuBar',
        name: '边框_虚线',
    },
    {
        id: 2164261276,
        label: '窗口 > 画笔库 > 边框 > 边框_装饰',
        placement: 'MenuBar',
        name: '边框_装饰',
    },
    {
        id: 2164261279,
        label: '窗口 > 画笔库 > 其它库...',
        placement: 'MenuBar',
        name: '其它库...',
    },
    {
        id: 2164261280,
        label: '窗口 > 路径查找器',
        placement: 'MenuBar',
        name: '路径查找器',
    },
    {
        id: 2164261281,
        label: '编辑 > 查找和替换...',
        placement: 'MenuBar',
        name: '查找和替换...',
    },
    {
        id: 2164261282,
        label: '编辑 > 查找下一个',
        placement: 'MenuBar',
        name: '查找下一个',
    },
    {
        id: 2164261283,
        label: '效果 > 栅格化...',
        placement: 'MenuBar',
        name: '栅格化...',
    },
    {
        id: 2164261285,
        label: '效果 > 文档栅格效果设置...',
        placement: 'MenuBar',
        name: '文档栅格效果设置...',
    },
    {
        id: 2164261286,
        label: '对象 > 栅格化...',
        placement: 'MenuBar',
        name: '栅格化...',
    },
    {
        id: 2164261288,
        label: '对象 > 混合 > 建立',
        placement: 'MenuBar',
        name: '建立',
    },
    {
        id: 2164261289,
        label: '对象 > 混合 > 释放',
        placement: 'MenuBar',
        name: '释放',
    },
    {
        id: 2164261291,
        label: '对象 > 混合 > 混合选项...',
        placement: 'MenuBar',
        name: '混合选项...',
    },
    {
        id: 2164261293,
        label: '对象 > 混合 > 扩展',
        placement: 'MenuBar',
        name: '扩展',
    },
    {
        id: 2164261295,
        label: '对象 > 混合 > 替换混合轴',
        placement: 'MenuBar',
        name: '替换混合轴',
    },
    {
        id: 2164261296,
        label: '对象 > 混合 > 反向混合轴',
        placement: 'MenuBar',
        name: '反向混合轴',
    },
    {
        id: 2164261297,
        label: '对象 > 混合 > 反向堆叠',
        placement: 'MenuBar',
        name: '反向堆叠',
    },
    {
        id: 2164261299,
        label: '视图 > 显示切片',
        placement: 'MenuBar',
        name: '显示切片',
    },
    {
        id: 2164261300,
        label: '视图 > 锁定切片',
        placement: 'MenuBar',
        name: '锁定切片',
    },
    {
        id: 2164261303,
        label: '对象 > 切片 > 建立',
        placement: 'MenuBar',
        name: '建立',
    },
    {
        id: 2164261304,
        label: '对象 > 切片 > 释放',
        placement: 'MenuBar',
        name: '释放',
    },
    {
        id: 2164261306,
        label: '对象 > 切片 > 从参考线创建',
        placement: 'MenuBar',
        name: '从参考线创建',
    },
    {
        id: 2164261307,
        label: '对象 > 切片 > 从所选对象创建',
        placement: 'MenuBar',
        name: '从所选对象创建',
    },
    {
        id: 2164261309,
        label: '对象 > 切片 > 复制切片',
        placement: 'MenuBar',
        name: '复制切片',
    },
    {
        id: 2164261310,
        label: '对象 > 切片 > 组合切片',
        placement: 'MenuBar',
        name: '组合切片',
    },
    {
        id: 2164261311,
        label: '对象 > 切片 > 划分切片...',
        placement: 'MenuBar',
        name: '划分切片...',
    },
    {
        id: 2164261312,
        label: '对象 > 切片 > 全部删除',
        placement: 'MenuBar',
        name: '全部删除',
    },
    {
        id: 2164261314,
        label: '对象 > 切片 > 切片选项...',
        placement: 'MenuBar',
        name: '切片选项...',
    },
    {
        id: 2164261316,
        label: '对象 > 切片 > 剪切到画板',
        placement: 'MenuBar',
        name: '剪切到画板',
    },
    {
        id: 2164261317,
        label: '窗口 > Retype',
        placement: 'MenuBar',
        name: 'Retype',
    },
    {
        id: 2164261318,
        label: '文件 > 存储选中的切片...',
        placement: 'MenuBar',
        name: '存储选中的切片...',
    },
    {
        id: 2164261320,
        label: '效果 > SVG 滤镜 > 应用 SVG 滤镜...',
        placement: 'MenuBar',
        name: '应用 SVG 滤镜...',
    },
    {
        id: 2164261321,
        label: '效果 > SVG 滤镜 > 导入 SVG 滤镜...',
        placement: 'MenuBar',
        name: '导入 SVG 滤镜...',
    },
    {
        id: 2164261323,
        label: '效果 > 风格化 > 羽化...',
        placement: 'MenuBar',
        name: '羽化...',
    },
    {
        id: 2164261325,
        label: '效果 > 3D 和材质 > 凸出和斜角...',
        placement: 'MenuBar',
        name: '凸出和斜角...',
    },
    {
        id: 2164261326,
        label: '效果 > 3D 和材质 > 绕转...',
        placement: 'MenuBar',
        name: '绕转...',
    },
    {
        id: 2164261327,
        label: '效果 > 3D 和材质 > 膨胀...',
        placement: 'MenuBar',
        name: '膨胀...',
    },
    {
        id: 2164261328,
        label: '效果 > 3D 和材质 > 旋转...',
        placement: 'MenuBar',
        name: '旋转...',
    },
    {
        id: 2164261329,
        label: '效果 > 3D 和材质 > 材质...',
        placement: 'MenuBar',
        name: '材质...',
    },
    {
        id: 2164261331,
        label: '效果 > 3D 和材质 > 3D（经典） > 凸出和斜角（经典）...',
        placement: 'MenuBar',
        name: '凸出和斜角（经典）...',
    },
    {
        id: 2164261332,
        label: '效果 > 3D 和材质 > 3D（经典） > 绕转（经典）...',
        placement: 'MenuBar',
        name: '绕转（经典）...',
    },
    {
        id: 2164261333,
        label: '效果 > 3D 和材质 > 3D（经典） > 旋转（经典）...',
        placement: 'MenuBar',
        name: '旋转（经典）...',
    },
    {
        id: 2164261334,
        label: '窗口 > SVG 交互',
        placement: 'MenuBar',
        name: 'SVG 交互',
    },
    {
        id: 2164261335,
        label: '对象 > 裁剪图像',
        placement: 'MenuBar',
        name: '裁剪图像',
    },
    {
        id: 2164261336,
        label: '窗口 > 变量',
        placement: 'MenuBar',
        name: '变量',
    },
    {
        id: 2164261338,
        label: '窗口 > 魔棒',
        placement: 'MenuBar',
        name: '魔棒',
    },
    {
        id: 2164261339,
        label: '对象 > 路径 > 分割下方对象',
        placement: 'MenuBar',
        name: '分割下方对象',
    },
    {
        id: 2164261340,
        label: '选择 > 对象 > 毛刷画笔描边',
        placement: 'MenuBar',
        name: '毛刷画笔描边',
    },
    {
        id: 2164261342,
        label: '对象 > 变换 > 重置定界框',
        placement: 'MenuBar',
        name: '重置定界框',
    },
    {
        id: 2164261343,
        label: '视图 > 隐藏定界框',
        placement: 'MenuBar',
        name: '隐藏定界框',
    },
    {
        id: 2164261344,
        label: '对象 > 排列 > 发送至当前图层',
        placement: 'MenuBar',
        name: '发送至当前图层',
    },
    {
        id: 2164261346,
        label: '对象 > 锁定 > 上方所有图稿',
        placement: 'MenuBar',
        name: '上方所有图稿',
    },
    {
        id: 2164261347,
        label: '对象 > 锁定 > 其它图层',
        placement: 'MenuBar',
        name: '其它图层',
    },
    {
        id: 2164261348,
        label: '对象 > 隐藏 > 上方所有图稿',
        placement: 'MenuBar',
        name: '上方所有图稿',
    },
    {
        id: 2164261349,
        label: '对象 > 隐藏 > 其它图层',
        placement: 'MenuBar',
        name: '其它图层',
    },
    {
        id: 2164261350,
        label: '选择 > 对象 > 同一图层上的所有对象',
        placement: 'MenuBar',
        name: '同一图层上的所有对象',
    },
    {
        id: 2164261351,
        label: '选择 > 对象 > 方向手柄',
        placement: 'MenuBar',
        name: '方向手柄',
    },
    {
        id: 2164261354,
        label: '选择 > 上方的下一个对象',
        placement: 'MenuBar',
        name: '上方的下一个对象',
    },
    {
        id: 2164261355,
        label: '选择 > 下方的下一个对象',
        placement: 'MenuBar',
        name: '下方的下一个对象',
    },
    {
        id: 2164261358,
        label: '选择 > 存储所选对象...',
        placement: 'MenuBar',
        name: '存储所选对象...',
    },
    {
        id: 2164261359,
        label: '选择 > 编辑所选对象...',
        placement: 'MenuBar',
        name: '编辑所选对象...',
    },
    {
        id: 2164261360,
        label: '选择 > 更新选区',
        placement: 'MenuBar',
        name: '更新选区',
    },
    {
        id: 2164261361,
        label: '对象 > 路径 > 简化...',
        placement: 'MenuBar',
        name: '简化...',
    },
    {
        id: 2164261362,
        label: '对象 > 路径 > 平滑...',
        placement: 'MenuBar',
        name: '平滑...',
    },
    {
        id: 2164261364,
        label: '对象 > 模型 > 预览模型',
        placement: 'MenuBar',
        name: '预览模型',
    },
    {
        id: 2164261365,
        label: '对象 > 模型 > 释放',
        placement: 'MenuBar',
        name: '释放',
    },
    {
        id: 2164261366,
        label: '对象 > 模型 > 编辑',
        placement: 'MenuBar',
        name: '编辑',
    },
    {
        id: 2164261367,
        label: '效果 > 扭曲和变换 > 扭转...',
        placement: 'MenuBar',
        name: '扭转...',
    },
    {
        id: 2164261371,
        label: '文件 > 脚本 > 其它脚本...',
        placement: 'MenuBar',
        name: '其它脚本...',
    },
    {
        id: 2164261372,
        label: '窗口 > CSS 属性（已弃用）',
        placement: 'MenuBar',
        name: 'CSS 属性（已弃用）',
    },
    {
        id: 2164261374,
        label: '效果 > 路径 > 轮廓化对象',
        placement: 'MenuBar',
        name: '轮廓化对象',
    },
    {
        id: 2164261375,
        label: '窗口 > 颜色',
        placement: 'MenuBar',
        name: '颜色',
    },
    {
        id: 2164261377,
        label: '窗口 > 渐变',
        placement: 'MenuBar',
        name: '渐变',
    },
    {
        id: 2164261378,
        label: '窗口 > 描边',
        placement: 'MenuBar',
        name: '描边',
    },
    {
        id: 2164261379,
        label: '视图 > 隐藏渐变批注者',
        placement: 'MenuBar',
        name: '隐藏渐变批注者',
    },
    {
        id: 2164261380,
        label: '对象 > 路径 > 反转路径方向',
        placement: 'MenuBar',
        name: '反转路径方向',
    },
    {
        id: 2164261381,
        label: '窗口 > 透明度',
        placement: 'MenuBar',
        name: '透明度',
    },
    {
        id: 2164261382,
        label: '视图 > 显示透明度网格',
        placement: 'MenuBar',
        name: '显示透明度网格',
    },
    {
        id: 2164261383,
        label: '窗口 > 色板',
        placement: 'MenuBar',
        name: '色板',
    },
    {
        id: 2164261386,
        label: '窗口 > 图案选项',
        placement: 'MenuBar',
        name: '图案选项',
    },
    {
        id: 2164261387,
        label: '窗口 > 生成图案 (Beta)',
        placement: 'MenuBar',
        name: '生成图案 (Beta)',
    },
    {
        id: 2164261389,
        label: '对象 > 图案 > 建立',
        placement: 'MenuBar',
        name: '建立',
    },
    {
        id: 2164261391,
        label: '对象 > 图案 > 编辑图案',
        placement: 'MenuBar',
        name: '编辑图案',
    },
    {
        id: 2164261392,
        label: '对象 > 图案 > 拼贴边缘颜色...',
        placement: 'MenuBar',
        name: '拼贴边缘颜色...',
    },
    {
        id: 2164261394,
        label: '对象 > 图案 > 生成图案 (Beta)',
        placement: 'MenuBar',
        name: '生成图案 (Beta)',
    },
    {
        id: 2164261395,
        label: '窗口 > 色板库 > VisiBone2',
        placement: 'MenuBar',
        name: 'VisiBone2',
    },
    {
        id: 2164261396,
        label: '窗口 > 色板库 > Web',
        placement: 'MenuBar',
        name: 'Web',
    },
    {
        id: 2164261397,
        label: '窗口 > 色板库 > 中性',
        placement: 'MenuBar',
        name: '中性',
    },
    {
        id: 2164261398,
        label: '窗口 > 色板库 > 儿童物品',
        placement: 'MenuBar',
        name: '儿童物品',
    },
    {
        id: 2164261399,
        label: '窗口 > 色板库 > 公司',
        placement: 'MenuBar',
        name: '公司',
    },
    {
        id: 2164261402,
        label: '窗口 > 色板库 > 图案 > 基本图形 > 基本图形_点',
        placement: 'MenuBar',
        name: '基本图形_点',
    },
    {
        id: 2164261403,
        label: '窗口 > 色板库 > 图案 > 基本图形 > 基本图形_纹理',
        placement: 'MenuBar',
        name: '基本图形_纹理',
    },
    {
        id: 2164261404,
        label: '窗口 > 色板库 > 图案 > 基本图形 > 基本图形_线条',
        placement: 'MenuBar',
        name: '基本图形_线条',
    },
    {
        id: 2164261406,
        label: '窗口 > 色板库 > 图案 > 自然 > 自然_动物皮',
        placement: 'MenuBar',
        name: '自然_动物皮',
    },
    {
        id: 2164261407,
        label: '窗口 > 色板库 > 图案 > 自然 > 自然_叶子',
        placement: 'MenuBar',
        name: '自然_叶子',
    },
    {
        id: 2164261409,
        label: '窗口 > 色板库 > 图案 > 装饰 > Vonster 图案',
        placement: 'MenuBar',
        name: 'Vonster 图案',
    },
    {
        id: 2164261410,
        label: '窗口 > 色板库 > 图案 > 装饰 > 装饰旧版',
        placement: 'MenuBar',
        name: '装饰旧版',
    },
    {
        id: 2164261411,
        label: '窗口 > 色板库 > 大地色调',
        placement: 'MenuBar',
        name: '大地色调',
    },
    {
        id: 2164261412,
        label: '窗口 > 色板库 > 庆祝',
        placement: 'MenuBar',
        name: '庆祝',
    },
    {
        id: 2164261414,
        label: '窗口 > 色板库 > 渐变 > 中性色',
        placement: 'MenuBar',
        name: '中性色',
    },
    {
        id: 2164261415,
        label: '窗口 > 色板库 > 渐变 > 叶子',
        placement: 'MenuBar',
        name: '叶子',
    },
    {
        id: 2164261416,
        label: '窗口 > 色板库 > 渐变 > 大地色调',
        placement: 'MenuBar',
        name: '大地色调',
    },
    {
        id: 2164261417,
        label: '窗口 > 色板库 > 渐变 > 天空',
        placement: 'MenuBar',
        name: '天空',
    },
    {
        id: 2164261418,
        label: '窗口 > 色板库 > 渐变 > 季节',
        placement: 'MenuBar',
        name: '季节',
    },
    {
        id: 2164261419,
        label: '窗口 > 色板库 > 渐变 > 明亮',
        placement: 'MenuBar',
        name: '明亮',
    },
    {
        id: 2164261420,
        label: '窗口 > 色板库 > 渐变 > 晕影',
        placement: 'MenuBar',
        name: '晕影',
    },
    {
        id: 2164261421,
        label: '窗口 > 色板库 > 渐变 > 木质',
        placement: 'MenuBar',
        name: '木质',
    },
    {
        id: 2164261422,
        label: '窗口 > 色板库 > 渐变 > 水',
        placement: 'MenuBar',
        name: '水',
    },
    {
        id: 2164261423,
        label: '窗口 > 色板库 > 渐变 > 水果和蔬菜',
        placement: 'MenuBar',
        name: '水果和蔬菜',
    },
    {
        id: 2164261424,
        label: '窗口 > 色板库 > 渐变 > 淡色和暗色',
        placement: 'MenuBar',
        name: '淡色和暗色',
    },
    {
        id: 2164261425,
        label: '窗口 > 色板库 > 渐变 > 渐隐',
        placement: 'MenuBar',
        name: '渐隐',
    },
    {
        id: 2164261426,
        label: '窗口 > 色板库 > 渐变 > 玉石和珠宝',
        placement: 'MenuBar',
        name: '玉石和珠宝',
    },
    {
        id: 2164261427,
        label: '窗口 > 色板库 > 渐变 > 石头和砖块',
        placement: 'MenuBar',
        name: '石头和砖块',
    },
    {
        id: 2164261428,
        label: '窗口 > 色板库 > 渐变 > 简单径向',
        placement: 'MenuBar',
        name: '简单径向',
    },
    {
        id: 2164261429,
        label: '窗口 > 色板库 > 渐变 > 肤色',
        placement: 'MenuBar',
        name: '肤色',
    },
    {
        id: 2164261430,
        label: '窗口 > 色板库 > 渐变 > 色彩调和',
        placement: 'MenuBar',
        name: '色彩调和',
    },
    {
        id: 2164261431,
        label: '窗口 > 色板库 > 渐变 > 色谱',
        placement: 'MenuBar',
        name: '色谱',
    },
    {
        id: 2164261432,
        label: '窗口 > 色板库 > 渐变 > 蜡笔',
        placement: 'MenuBar',
        name: '蜡笔',
    },
    {
        id: 2164261433,
        label: '窗口 > 色板库 > 渐变 > 金属',
        placement: 'MenuBar',
        name: '金属',
    },
    {
        id: 2164261434,
        label: '窗口 > 色板库 > 渐变 > 颜色组合',
        placement: 'MenuBar',
        name: '颜色组合',
    },
    {
        id: 2164261436,
        label: '窗口 > 色板库 > 科学 > 三色组合',
        placement: 'MenuBar',
        name: '三色组合',
    },
    {
        id: 2164261437,
        label: '窗口 > 色板库 > 科学 > 互补色',
        placement: 'MenuBar',
        name: '互补色',
    },
    {
        id: 2164261438,
        label: '窗口 > 色板库 > 科学 > 分裂互补色',
        placement: 'MenuBar',
        name: '分裂互补色',
    },
    {
        id: 2164261439,
        label: '窗口 > 色板库 > 科学 > 四色组合',
        placement: 'MenuBar',
        name: '四色组合',
    },
    {
        id: 2164261440,
        label: '窗口 > 色板库 > 科学 > 近似色',
        placement: 'MenuBar',
        name: '近似色',
    },
    {
        id: 2164261441,
        label: '窗口 > 色板库 > 系统 (Macintosh)',
        placement: 'MenuBar',
        name: '系统 (Macintosh)',
    },
    {
        id: 2164261442,
        label: '窗口 > 色板库 > 系统 (Windows)',
        placement: 'MenuBar',
        name: '系统 (Windows)',
    },
    {
        id: 2164261443,
        label: '窗口 > 色板库 > 纺织品',
        placement: 'MenuBar',
        name: '纺织品',
    },
    {
        id: 2164261444,
        label: '窗口 > 色板库 > 肤色',
        placement: 'MenuBar',
        name: '肤色',
    },
    {
        id: 2164261446,
        label: '窗口 > 色板库 > 自然 > 叶子',
        placement: 'MenuBar',
        name: '叶子',
    },
    {
        id: 2164261447,
        label: '窗口 > 色板库 > 自然 > 季节',
        placement: 'MenuBar',
        name: '季节',
    },
    {
        id: 2164261448,
        label: '窗口 > 色板库 > 自然 > 海滩',
        placement: 'MenuBar',
        name: '海滩',
    },
    {
        id: 2164261449,
        label: '窗口 > 色板库 > 自然 > 石头和砖块',
        placement: 'MenuBar',
        name: '石头和砖块',
    },
    {
        id: 2164261450,
        label: '窗口 > 色板库 > 自然 > 花朵',
        placement: 'MenuBar',
        name: '花朵',
    },
    {
        id: 2164261451,
        label: '窗口 > 色板库 > 自然 > 风景',
        placement: 'MenuBar',
        name: '风景',
    },
    {
        id: 2164261453,
        label: '窗口 > 色板库 > 色标簿 > ANPA Color',
        placement: 'MenuBar',
        name: 'ANPA Color',
    },
    {
        id: 2164261454,
        label: '窗口 > 色板库 > 色标簿 > DIC Color Guide',
        placement: 'MenuBar',
        name: 'DIC Color Guide',
    },
    {
        id: 2164261455,
        label: '窗口 > 色板库 > 色标簿 > FOCOLTONE',
        placement: 'MenuBar',
        name: 'FOCOLTONE',
    },
    {
        id: 2164261456,
        label: '窗口 > 色板库 > 色标簿 > HKS E Process',
        placement: 'MenuBar',
        name: 'HKS E Process',
    },
    {
        id: 2164261457,
        label: '窗口 > 色板库 > 色标簿 > HKS E',
        placement: 'MenuBar',
        name: 'HKS E',
    },
    {
        id: 2164261458,
        label: '窗口 > 色板库 > 色标簿 > HKS K Process',
        placement: 'MenuBar',
        name: 'HKS K Process',
    },
    {
        id: 2164261459,
        label: '窗口 > 色板库 > 色标簿 > HKS K',
        placement: 'MenuBar',
        name: 'HKS K',
    },
    {
        id: 2164261460,
        label: '窗口 > 色板库 > 色标簿 > HKS N Process',
        placement: 'MenuBar',
        name: 'HKS N Process',
    },
    {
        id: 2164261461,
        label: '窗口 > 色板库 > 色标簿 > HKS N',
        placement: 'MenuBar',
        name: 'HKS N',
    },
    {
        id: 2164261462,
        label: '窗口 > 色板库 > 色标簿 > HKS Z Process',
        placement: 'MenuBar',
        name: 'HKS Z Process',
    },
    {
        id: 2164261463,
        label: '窗口 > 色板库 > 色标簿 > HKS Z',
        placement: 'MenuBar',
        name: 'HKS Z',
    },
    {
        id: 2164261464,
        label: '窗口 > 色板库 > 色标簿 > TOYO 94 COLOR FINDER',
        placement: 'MenuBar',
        name: 'TOYO 94 COLOR FINDER',
    },
    {
        id: 2164261465,
        label: '窗口 > 色板库 > 色标簿 > TOYO Color Finder',
        placement: 'MenuBar',
        name: 'TOYO Color Finder',
    },
    {
        id: 2164261466,
        label: '窗口 > 色板库 > 色标簿 > TRUMATCH',
        placement: 'MenuBar',
        name: 'TRUMATCH',
    },
    {
        id: 2164261468,
        label: '窗口 > 色板库 > 艺术史 > 中世纪风格',
        placement: 'MenuBar',
        name: '中世纪风格',
    },
    {
        id: 2164261469,
        label: '窗口 > 色板库 > 艺术史 > 俄国海报艺术风格',
        placement: 'MenuBar',
        name: '俄国海报艺术风格',
    },
    {
        id: 2164261470,
        label: '窗口 > 色板库 > 艺术史 > 印象派风格',
        placement: 'MenuBar',
        name: '印象派风格',
    },
    {
        id: 2164261471,
        label: '窗口 > 色板库 > 艺术史 > 史前风格',
        placement: 'MenuBar',
        name: '史前风格',
    },
    {
        id: 2164261472,
        label: '窗口 > 色板库 > 艺术史 > 巴洛克风格',
        placement: 'MenuBar',
        name: '巴洛克风格',
    },
    {
        id: 2164261473,
        label: '窗口 > 色板库 > 艺术史 > 文艺复兴风格',
        placement: 'MenuBar',
        name: '文艺复兴风格',
    },
    {
        id: 2164261474,
        label: '窗口 > 色板库 > 艺术史 > 流行艺术风格',
        placement: 'MenuBar',
        name: '流行艺术风格',
    },
    {
        id: 2164261475,
        label: '窗口 > 色板库 > 艺术史 > 远古风格',
        placement: 'MenuBar',
        name: '远古风格',
    },
    {
        id: 2164261476,
        label: '窗口 > 色板库 > 金属',
        placement: 'MenuBar',
        name: '金属',
    },
    {
        id: 2164261478,
        label: '窗口 > 色板库 > 颜色属性 > 不饱和色',
        placement: 'MenuBar',
        name: '不饱和色',
    },
    {
        id: 2164261479,
        label: '窗口 > 色板库 > 颜色属性 > 亮色',
        placement: 'MenuBar',
        name: '亮色',
    },
    {
        id: 2164261480,
        label: '窗口 > 色板库 > 颜色属性 > 冷色',
        placement: 'MenuBar',
        name: '冷色',
    },
    {
        id: 2164261481,
        label: '窗口 > 色板库 > 颜色属性 > 暖色',
        placement: 'MenuBar',
        name: '暖色',
    },
    {
        id: 2164261482,
        label: '窗口 > 色板库 > 颜色属性 > 暗色',
        placement: 'MenuBar',
        name: '暗色',
    },
    {
        id: 2164261483,
        label: '窗口 > 色板库 > 颜色属性 > 柔和色',
        placement: 'MenuBar',
        name: '柔和色',
    },
    {
        id: 2164261484,
        label: '窗口 > 色板库 > 颜色属性 > 浅色',
        placement: 'MenuBar',
        name: '浅色',
    },
    {
        id: 2164261485,
        label: '窗口 > 色板库 > 颜色属性 > 饱和色',
        placement: 'MenuBar',
        name: '饱和色',
    },
    {
        id: 2164261487,
        label: '窗口 > 色板库 > 食品 > 冰淇淋',
        placement: 'MenuBar',
        name: '冰淇淋',
    },
    {
        id: 2164261488,
        label: '窗口 > 色板库 > 食品 > 水果',
        placement: 'MenuBar',
        name: '水果',
    },
    {
        id: 2164261489,
        label: '窗口 > 色板库 > 食品 > 甜品',
        placement: 'MenuBar',
        name: '甜品',
    },
    {
        id: 2164261490,
        label: '窗口 > 色板库 > 食品 > 蔬菜',
        placement: 'MenuBar',
        name: '蔬菜',
    },
    {
        id: 2164261491,
        label: '窗口 > 色板库 > 食品 > 饮料',
        placement: 'MenuBar',
        name: '饮料',
    },
    {
        id: 2164261493,
        label: '窗口 > 色板库 > 默认色板 > Web',
        placement: 'MenuBar',
        name: 'Web',
    },
    {
        id: 2164261494,
        label: '窗口 > 色板库 > 默认色板 > 基本 RGB',
        placement: 'MenuBar',
        name: '基本 RGB',
    },
    {
        id: 2164261495,
        label: '窗口 > 色板库 > 默认色板 > 打印',
        placement: 'MenuBar',
        name: '打印',
    },
    {
        id: 2164261496,
        label: '窗口 > 色板库 > 默认色板 > 视频和胶片',
        placement: 'MenuBar',
        name: '视频和胶片',
    },
    {
        id: 2164261497,
        label: '窗口 > 色板库 > 默认色板 > 设备',
        placement: 'MenuBar',
        name: '设备',
    },
    {
        id: 2164261500,
        label: '窗口 > 色板库 > 其它库...',
        placement: 'MenuBar',
        name: '其它库...',
    },
    {
        id: 2164261501,
        label: '窗口 > 颜色参考',
        placement: 'MenuBar',
        name: '颜色参考',
    },
    {
        id: 2164261502,
        label: '编辑 > 编辑颜色 > 重新着色图稿...',
        placement: 'MenuBar',
        name: '重新着色图稿...',
    },
    {
        id: 2164261505,
        label: '编辑 > 编辑颜色 > 生成式重新着色',
        placement: 'MenuBar',
        name: '生成式重新着色',
    },
    {
        id: 2164261507,
        label: '编辑 > 编辑颜色 > 使用预设值重新着色 > 颜色库...',
        placement: 'MenuBar',
        name: '颜色库...',
    },
    {
        id: 2164261508,
        label: '编辑 > 编辑颜色 > 使用预设值重新着色 > 单色',
        placement: 'MenuBar',
        name: '单色',
    },
    {
        id: 2164261509,
        label: '编辑 > 编辑颜色 > 使用预设值重新着色 > 双色',
        placement: 'MenuBar',
        name: '双色',
    },
    {
        id: 2164261510,
        label: '编辑 > 编辑颜色 > 使用预设值重新着色 > 三色',
        placement: 'MenuBar',
        name: '三色',
    },
    {
        id: 2164261511,
        label: '编辑 > 编辑颜色 > 使用预设值重新着色 > 颜色协调',
        placement: 'MenuBar',
        name: '颜色协调',
    },
    {
        id: 2164261512,
        label: '窗口 > 控制',
        placement: 'MenuBar',
        name: '控制',
    },
    {
        id: 2164261513,
        label: '窗口 > 上下文任务栏',
        placement: 'MenuBar',
        name: '上下文任务栏',
    },
    {
        id: 2164261515,
        label: '对象 > 缠绕 > 建立',
        placement: 'MenuBar',
        name: '建立',
    },
    {
        id: 2164261516,
        label: '对象 > 缠绕 > 释放',
        placement: 'MenuBar',
        name: '释放',
    },
    {
        id: 2164261517,
        label: '对象 > 缠绕 > 编辑',
        placement: 'MenuBar',
        name: '编辑',
    },
    {
        id: 2164261518,
        label: '窗口 > 对齐',
        placement: 'MenuBar',
        name: '对齐',
    },
    {
        id: 2164261520,
        label: '对象 > 对齐 > 水平左对齐',
        placement: 'MenuBar',
        name: '水平左对齐',
    },
    {
        id: 2164261521,
        label: '对象 > 对齐 > 水平居中对齐',
        placement: 'MenuBar',
        name: '水平居中对齐',
    },
    {
        id: 2164261522,
        label: '对象 > 对齐 > 水平右对齐',
        placement: 'MenuBar',
        name: '水平右对齐',
    },
    {
        id: 2164261523,
        label: '对象 > 对齐 > 垂直顶对齐',
        placement: 'MenuBar',
        name: '垂直顶对齐',
    },
    {
        id: 2164261524,
        label: '对象 > 对齐 > 垂直居中对齐',
        placement: 'MenuBar',
        name: '垂直居中对齐',
    },
    {
        id: 2164261525,
        label: '对象 > 对齐 > 垂直底对齐',
        placement: 'MenuBar',
        name: '垂直底对齐',
    },
    {
        id: 2164261527,
        label: '对象 > 分布 > 垂直顶分布',
        placement: 'MenuBar',
        name: '垂直顶分布',
    },
    {
        id: 2164261528,
        label: '对象 > 分布 > 垂直居中分布',
        placement: 'MenuBar',
        name: '垂直居中分布',
    },
    {
        id: 2164261529,
        label: '对象 > 分布 > 垂直底分布',
        placement: 'MenuBar',
        name: '垂直底分布',
    },
    {
        id: 2164261530,
        label: '对象 > 分布 > 水平左分布',
        placement: 'MenuBar',
        name: '水平左分布',
    },
    {
        id: 2164261531,
        label: '对象 > 分布 > 水平居中分布',
        placement: 'MenuBar',
        name: '水平居中分布',
    },
    {
        id: 2164261532,
        label: '对象 > 分布 > 水平右分布',
        placement: 'MenuBar',
        name: '水平右分布',
    },
    {
        id: 2164261533,
        label: '窗口 > 变换',
        placement: 'MenuBar',
        name: '变换',
    },
    {
        id: 2164261534,
        label: '视图 > 隐藏边角构件',
        placement: 'MenuBar',
        name: '隐藏边角构件',
    },
    {
        id: 2164261536,
        label: '对象 > 重复 > 径向',
        placement: 'MenuBar',
        name: '径向',
    },
    {
        id: 2164261537,
        label: '对象 > 重复 > 网格',
        placement: 'MenuBar',
        name: '网格',
    },
    {
        id: 2164261538,
        label: '对象 > 重复 > 镜像',
        placement: 'MenuBar',
        name: '镜像',
    },
    {
        id: 2164261540,
        label: '对象 > 重复 > 释放',
        placement: 'MenuBar',
        name: '释放',
    },
    {
        id: 2164261541,
        label: '对象 > 重复 > 选项...',
        placement: 'MenuBar',
        name: '选项...',
    },
    {
        id: 2164261543,
        label: '对象 > 路径上的对象 > 附加...',
        placement: 'MenuBar',
        name: '附加...',
    },
    {
        id: 2164261544,
        label: '对象 > 路径上的对象 > 选项...',
        placement: 'MenuBar',
        name: '选项...',
    },
    {
        id: 2164261545,
        label: '对象 > 路径上的对象 > 展开',
        placement: 'MenuBar',
        name: '展开',
    },
    {
        id: 2164261546,
        label: '效果 > 路径 > 轮廓化描边',
        placement: 'MenuBar',
        name: '轮廓化描边',
    },
    {
        id: 2164261547,
        label: '效果 > 路径 > 偏移路径...',
        placement: 'MenuBar',
        name: '偏移路径...',
    },
    {
        id: 2164261548,
        label: '对象 > 路径 > 轮廓化描边',
        placement: 'MenuBar',
        name: '轮廓化描边',
    },
    {
        id: 2164261549,
        label: '对象 > 路径 > 偏移路径...',
        placement: 'MenuBar',
        name: '偏移路径...',
    },
    {
        id: 2164261551,
        label: '窗口 > 工具栏 > 基本',
        placement: 'MenuBar',
        name: '基本',
    },
    {
        id: 2164261552,
        label: '窗口 > 工具栏 > 高级',
        placement: 'MenuBar',
        name: '高级',
    },
    {
        id: 2164261553,
        label: '窗口 > 工具栏 > Getting Started',
        placement: 'MenuBar',
        name: 'Getting Started',
    },
    {
        id: 2164261555,
        label: '窗口 > 工具栏 > 新建工具栏...',
        placement: 'MenuBar',
        name: '新建工具栏...',
    },
    {
        id: 2164261556,
        label: '窗口 > 工具栏 > 管理工具栏...',
        placement: 'MenuBar',
        name: '管理工具栏...',
    },
    {
        id: 2164261557,
        label: '窗口 > 特性',
        placement: 'MenuBar',
        name: '特性',
    },
    {
        id: 2164261558,
        label: '文字 > Adobe Fonts 提供更多字体与功能...',
        placement: 'MenuBar',
        name: 'Adobe Fonts 提供更多字体与功能...',
    },
    {
        id: 2164261559,
        label: '文字 > 解决缺失字体...',
        placement: 'MenuBar',
        name: '解决缺失字体...',
    },
    {
        id: 2164261560,
        label: '帮助 > 支持社区',
        placement: 'MenuBar',
        name: '支持社区',
    },
    {
        id: 2164261561,
        label: '帮助 > 提交错误/功能请求...',
        placement: 'MenuBar',
        name: '提交错误/功能请求...',
    },
    {
        id: 2164261563,
        label: '对象 > 设为像素级优化',
        placement: 'MenuBar',
        name: '设为像素级优化',
    },
    {
        id: 2164261564,
        label: '窗口 > 文字 > Reflow 查看器',
        placement: 'MenuBar',
        name: 'Reflow 查看器',
    },
    {
        id: 2164261565,
        label: '帮助 > 生成式 AI 用户指南',
        placement: 'MenuBar',
        name: '生成式 AI 用户指南',
    },
    {
        id: 2164261567,
        label: '编辑 > 打印预设...',
        placement: 'MenuBar',
        name: '打印预设...',
    },
    {
        id: 2164261569,
        label: '文件 > 打印...',
        placement: 'MenuBar',
        name: '打印...',
    },
    {
        id: 2164261570,
        label: '编辑 > 透明度拼合器预设...',
        placement: 'MenuBar',
        name: '透明度拼合器预设...',
    },
    {
        id: 2164261571,
        label: '对象 > 拼合透明度...',
        placement: 'MenuBar',
        name: '拼合透明度...',
    },
    {
        id: 2164261573,
        label: '对象 > 形状 > 转换为形状',
        placement: 'MenuBar',
        name: '转换为形状',
    },
    {
        id: 2164261574,
        label: '对象 > 形状 > 扩展形状',
        placement: 'MenuBar',
        name: '扩展形状',
    },
    {
        id: 2164261575,
        label: '窗口 > 模型',
        placement: 'MenuBar',
        name: '模型',
    },
    {
        id: 2164261576,
        label: '窗口 > 生成的变体',
        placement: 'MenuBar',
        name: '生成的变体',
    },
    {
        id: 2164261577,
        label: '对象 > 生成矢量 (Beta)...',
        placement: 'MenuBar',
        name: '生成矢量 (Beta)...',
    },
    {
        id: 2164261578,
        label: '文件 > 生成矢量 (Beta)...',
        placement: 'MenuBar',
        name: '生成矢量 (Beta)...',
    },
    {
        id: 2164261579,
        label: '对象 > 生成式形状填充 (Beta)...',
        placement: 'MenuBar',
        name: '生成式形状填充 (Beta)...',
    },
    {
        id: 2164261580,
        label: '窗口 > 3D 和材质',
        placement: 'MenuBar',
        name: '3D 和材质',
    },
    {
        id: 2164261582,
        label: '对象 > 透视 > 附加到现用平面',
        placement: 'MenuBar',
        name: '附加到现用平面',
    },
    {
        id: 2164261583,
        label: '对象 > 透视 > 通过透视释放',
        placement: 'MenuBar',
        name: '通过透视释放',
    },
    {
        id: 2164261584,
        label: '对象 > 透视 > 移动平面以匹配对象',
        placement: 'MenuBar',
        name: '移动平面以匹配对象',
    },
    {
        id: 2164261585,
        label: '对象 > 透视 > 编辑文本',
        placement: 'MenuBar',
        name: '编辑文本',
    },
    {
        id: 2164261586,
        label: '编辑 > 透视网格预设...',
        placement: 'MenuBar',
        name: '透视网格预设...',
    },
    {
        id: 2164261589,
        label: '视图 > 透视网格 > 显示网格',
        placement: 'MenuBar',
        name: '显示网格',
    },
    {
        id: 2164261590,
        label: '视图 > 透视网格 > 显示标尺',
        placement: 'MenuBar',
        name: '显示标尺',
    },
    {
        id: 2164261591,
        label: '视图 > 透视网格 > 对齐网格',
        placement: 'MenuBar',
        name: '对齐网格',
    },
    {
        id: 2164261592,
        label: '视图 > 透视网格 > 锁定网格',
        placement: 'MenuBar',
        name: '锁定网格',
    },
    {
        id: 2164261593,
        label: '视图 > 透视网格 > 锁定站点',
        placement: 'MenuBar',
        name: '锁定站点',
    },
    {
        id: 2164261595,
        label: '视图 > 透视网格 > 定义网格...',
        placement: 'MenuBar',
        name: '定义网格...',
    },
    {
        id: 2164261601,
        label: '视图 > 透视网格 > 将网格存储为预设...',
        placement: 'MenuBar',
        name: '将网格存储为预设...',
    },
    {
        id: 2164261602,
        label: '窗口 > 图像描摹',
        placement: 'MenuBar',
        name: '图像描摹',
    },
    {
        id: 2164261604,
        label: '对象 > 图像描摹 > 建立',
        placement: 'MenuBar',
        name: '建立',
    },
    {
        id: 2164261605,
        label: '对象 > 图像描摹 > 建立并扩展',
        placement: 'MenuBar',
        name: '建立并扩展',
    },
    {
        id: 2164261606,
        label: '对象 > 图像描摹 > 释放',
        placement: 'MenuBar',
        name: '释放',
    },
    {
        id: 2164261608,
        label: '对象 > 图像描摹 > 扩展',
        placement: 'MenuBar',
        name: '扩展',
    },
    {
        id: 2164261609,
        label: '效果 > 模糊 > 高斯模糊...',
        placement: 'MenuBar',
        name: '高斯模糊...',
    },
    {
        id: 2164261610,
        label: '编辑 > Adobe PDF 预设...',
        placement: 'MenuBar',
        name: 'Adobe PDF 预设...',
    },
    {
        id: 2164261611,
        label: '窗口 > 资源导出',
        placement: 'MenuBar',
        name: '资源导出',
    },
    {
        id: 2164261612,
        label: '文件 > 邀请编辑...',
        placement: 'MenuBar',
        name: '邀请编辑...',
    },
    {
        id: 2164261613,
        label: '文件 > 共享以供审阅...',
        placement: 'MenuBar',
        name: '共享以供审阅...',
    },
    {
        id: 2164261614,
        label: '视图 > 透视网格 > 一点透视 > [一点-正常视图]',
        placement: 'MenuBar',
        name: '[一点-正常视图]',
    },
    {
        id: 2164261615,
        label: '视图 > 透视网格 > 两点透视 > [两点-正常视图]',
        placement: 'MenuBar',
        name: '[两点-正常视图]',
    },
    {
        id: 2164261616,
        label: '视图 > 透视网格 > 三点透视 > [三点-正常视图]',
        placement: 'MenuBar',
        name: '[三点-正常视图]',
    },
    {
        id: 2164261619,
        label: '窗口 > 扩展功能 > 库',
        placement: 'MenuBar',
        name: '库',
    },
    {
        id: 2164261620,
        label: '窗口 > 版本历史记录',
        placement: 'MenuBar',
        name: '版本历史记录',
    },
    {
        id: 2164261621,
        label: '文件 > 版本历史记录',
        placement: 'MenuBar',
        name: '版本历史记录',
    },
    {
        id: 2164261622,
        label: '窗口 > 注释',
        placement: 'MenuBar',
        name: '注释',
    },
    {
        id: 'Adobe Scroll Tool',
        label: '抓手工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Pen Tool',
        label: '钢笔工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scale Tool',
        label: '比例缩放工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rotate Tool',
        label: '旋转工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Reflect Tool',
        label: '镜像工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shear Tool',
        label: '倾斜工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scissors Tool',
        label: '剪刀工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Measure Tool',
        label: '度量工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Page Tool',
        label: '打印拼贴工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Direct Object Select Tool',
        label: '编组选择工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Direct Select Tool',
        label: '直接选择工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Select Tool',
        label: '选择工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Zoom Tool',
        label: '缩放工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Add Anchor Point Tool',
        label: '添加锚点工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Delete Anchor Point Tool',
        label: '删除锚点工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Anchor Point Tool',
        label: '锚点工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Column Graph Tool',
        label: '柱形图工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Stacked Column Graph Tool',
        label: '堆积柱形图工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Line Graph Tool',
        label: '折线图工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Pie Graph Tool',
        label: '饼图工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Area Graph Tool',
        label: '面积图工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scatter Graph Tool',
        label: '散点图工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Bar Graph Tool',
        label: '条形图工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Stacked Bar Graph Tool',
        label: '堆积条形图工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Radar Graph Tool',
        label: '雷达图工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Mesh Editing Tool',
        label: '网格工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Type Tool',
        label: '文字工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Area Type Tool',
        label: '区域文字工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Path Type Tool',
        label: '路径文字工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Vertical Type Tool',
        label: '直排文字工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Vertical Area Type Tool',
        label: '直排区域文字工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Vertical Path Type Tool',
        label: '直排路径文字工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Touch Type Tool',
        label: '修饰文字工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Builder Tool',
        label: '形状生成器工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Planar Paintbucket Tool',
        label: '实时上色工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Planar Face Select Tool',
        label: '实时上色选择工具',
        placement: 'Tool',
    },
    {
        id: 'Perspective Grid Tool',
        label: '透视网格工具',
        placement: 'Tool',
    },
    {
        id: 'Perspective Selection Tool',
        label: '透视选区工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Blend Tool',
        label: '混合工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Slice Tool',
        label: '切片工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Slice Select Tool',
        label: '切片选择工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Direct Lasso Tool',
        label: '套索工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Crop Tool',
        label: '画板工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Curvature Tool',
        label: '曲率工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shaper Tool',
        label: 'Shaper 工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Puppet Warp Tool',
        label: '操控变形工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Magic Wand Tool',
        label: '魔棒工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Knife Tool',
        label: '美工刀工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Flare Tool',
        label: '光晕工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Free Transform Tool',
        label: '自由变换工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Line Tool',
        label: '直线段工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Arc Tool',
        label: '弧形工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rectangular Grid Tool',
        label: '矩形网格工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Polar Grid Tool',
        label: '极坐标网格工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Warp Tool',
        label: '变形工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe New Twirl Tool',
        label: '旋转扭曲工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Pucker Tool',
        label: '缩拢工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Bloat Tool',
        label: '膨胀工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scallop Tool',
        label: '扇贝工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Cyrstallize Tool',
        label: '晶格化工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Wrinkle Tool',
        label: '皱褶工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Quick Pen Tool',
        label: '快速钢笔工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Freehand Tool',
        label: '铅笔工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Brush Tool',
        label: '画笔工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Blob Brush Tool',
        label: '斑点画笔工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Freehand Smooth Tool',
        label: '平滑工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Freehand Erase Tool',
        label: '路径橡皮檫工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Corner Join Tool',
        label: '连接工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Ellipse Shape Tool',
        label: '椭圆工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Construction Regular Polygon Tool',
        label: '多边形工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Construction Star Tool',
        label: '星形工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rectangle Shape Tool',
        label: '矩形工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rounded Rectangle Tool',
        label: '圆角矩形工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Construction Spiral Tool',
        label: '螺旋线工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Sprayer Tool',
        label: '符号喷枪工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Shifter Tool',
        label: '符号移位器工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Scruncher Tool',
        label: '符号紧缩器工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Sizer Tool',
        label: '符号缩放器工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Spinner Tool',
        label: '符号旋转器工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Stainer Tool',
        label: '符号着色器工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Screener Tool',
        label: '符号滤色器工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Styler Tool',
        label: '符号样式器工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Gradient Vector Tool',
        label: '渐变工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Dimension Tool',
        label: '维度工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Constraints Tool',
        label: '路径上的对象',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rotate Canvas Tool',
        label: '旋转视图工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Reshape Tool',
        label: '整形工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Width Tool',
        label: '宽度工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Eraser Tool',
        label: '橡皮擦工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Eyedropper Tool',
        label: '吸管工具',
        placement: 'Tool',
    },
    {
        id: '3D and Materials',
        label: '3D 和材质',
        placement: 'Panel',
    },
    {
        id: 'Actions',
        label: '动作',
        placement: 'Panel',
    },
    {
        id: 'AdobeAltGlyphsPanel',
        label: '字形',
        placement: 'Panel',
    },
    {
        id: 'AdobeBrush',
        label: '画笔',
        placement: 'Panel',
    },
    {
        id: 'AdobeCharStyles',
        label: '字符样式',
        placement: 'Panel',
    },
    {
        id: 'AdobeColorGuidePanel',
        label: '颜色参考',
        placement: 'Panel',
    },
    {
        id: 'AdobeFlatteningPreview',
        label: '拼合器预览',
        placement: 'Panel',
    },
    {
        id: 'AdobeGradientEditor',
        label: '渐变',
        placement: 'Panel',
    },
    {
        id: 'AdobeHorizontalTabPanel',
        label: '制表符',
        placement: 'Panel',
    },
    {
        id: 'AdobeLayerPalette',
        label: '图层',
        placement: 'Panel',
    },
    {
        id: 'AdobeObjectAttributes',
        label: '特性',
        placement: 'Panel',
    },
    {
        id: 'AdobeOpenTypeFont',
        label: 'OpenType',
        placement: 'Panel',
    },
    {
        id: 'AdobeParaStyles',
        label: '段落样式',
        placement: 'Panel',
    },
    {
        id: 'AdobePropertiesPanel',
        label: '属性',
        placement: 'Panel',
    },
    {
        id: 'AdobeSeparationPreview',
        label: '分色预览',
        placement: 'Panel',
    },
    {
        id: 'AdobeSwatch_',
        label: '色板',
        placement: 'Panel',
    },
    {
        id: 'AdobeVariablesPanel',
        label: '变量',
        placement: 'Panel',
    },
    {
        id: 'AdobeVerticalTabPanel',
        label: '制表符',
        placement: 'Panel',
    },
    {
        id: 'Align',
        label: '对齐',
        placement: 'Panel',
    },
    {
        id: 'Appearance',
        label: '外观',
        placement: 'Panel',
    },
    {
        id: 'Artboards',
        label: '画板',
        placement: 'Panel',
    },
    {
        id: 'CCX Commenting UXP Webview',
        label: '注释',
        placement: 'Panel',
    },
    {
        id: 'CSS',
        label: 'CSS 属性（已弃用）',
        placement: 'Panel',
    },
    {
        id: 'CSXSExtension_com.adobe.DesignLibraries.angular_0',
        label: '库',
        placement: 'Panel',
    },
    {
        id: 'Character',
        label: '字符',
        placement: 'Panel',
    },
    {
        id: 'Color',
        label: '颜色',
        placement: 'Panel',
    },
    {
        id: 'Document Info',
        label: '文档信息',
        placement: 'Panel',
    },
    {
        id: 'Export',
        label: '资源导出',
        placement: 'Panel',
    },
    {
        id: 'GeneratedVariations',
        label: '生成的变体',
        placement: 'Panel',
    },
    {
        id: 'History',
        label: '历史记录',
        placement: 'Panel',
    },
    {
        id: 'Info',
        label: '信息',
        placement: 'Panel',
    },
    {
        id: 'Links',
        label: '链接',
        placement: 'Panel',
    },
    {
        id: 'Magic Wand',
        label: '魔棒',
        placement: 'Panel',
    },
    {
        id: 'Mockup',
        label: '模型',
        placement: 'Panel',
    },
    {
        id: 'NamedStyle',
        label: '图形样式',
        placement: 'Panel',
    },
    {
        id: 'Navigator',
        label: '导航器',
        placement: 'Panel',
    },
    {
        id: 'Paragraph',
        label: '段落',
        placement: 'Panel',
    },
    {
        id: 'Pathfinder',
        label: '路径查找器',
        placement: 'Panel',
    },
    {
        id: 'PatternOptionsPanel',
        label: '图案选项',
        placement: 'Panel',
    },
    {
        id: 'Reflow Viewer',
        label: 'Reflow 查看器',
        placement: 'Panel',
    },
    {
        id: 'Retype',
        label: 'Retype',
        placement: 'Panel',
    },
    {
        id: 'SVGInteractivity',
        label: 'SVG 交互',
        placement: 'Panel',
    },
    {
        id: 'Stroke',
        label: '描边',
        placement: 'Panel',
    },
    {
        id: 'Symbols',
        label: '符号',
        placement: 'Panel',
    },
    {
        id: 'Transform',
        label: '变换',
        placement: 'Panel',
    },
    {
        id: 'Transparency',
        label: '透明度',
        placement: 'Panel',
    },
    {
        id: 'Vectorize',
        label: '图像描摹',
        placement: 'Panel',
    },
    {
        id: 'ccx-timeline',
        label: '版本历史记录',
        placement: 'Panel',
    },
];
